export const QUESTIONS = [
  {
    "id": 1,
    "question": "What is a reason a generative AI tool like GitHub Copilot might create low-quality code?",
    "choice_a": "It uses private codebases as training data.",
    "choice_b": "Sometimes the underlying dataset for the model is low quality.",
    "choice_c": "It has difficulties with common programming languages.",
    "choice_d": "There is not enough labeled data.",
    "correct_answer": "B",
    "explanation": "Generative AI models for software development are trained on huge amounts of code from public repositories, such as GitHub. However, there may be low quality code. This can result in code generation that may be verbose or difficult to maintain. For more information, see Chapter 1, “The Fundamentals of AI and Its Responsible Use.”",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      20,
      7,
      44,
      9,
      17
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 2,
    "question": "Which of the following is a way to protect privacy in an AI system?",
    "choice_a": "Make data public in a repository.",
    "choice_b": "Use only old data to avoid personal information.",
    "choice_c": "Encrypt and anonymize data.",
    "choice_d": "Only rely on automated safety filters.",
    "correct_answer": "C",
    "explanation": "GitHub recommends that privacy should be protected by encrypting and anonymizing data. For more information, see Chapter 1, “The Fundamentals of AI and Its Responsible Use.”",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      27,
      26,
      44,
      19
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 3,
    "question": "How can you improve fairness in an AI system?",
    "choice_a": "Only use AI systems for non-sensitive tasks.",
    "choice_b": "Focus on small datasets.",
    "choice_c": "Use proprietary datasets.",
    "choice_d": "Use a diverse team and review datasets.",
    "correct_answer": "D",
    "explanation": "Microsoft recommends having diverse teams develop AI models. There should also be regular human reviews. For more information, see Chapter 1, “The Fundamentals of AI and Its Responsible Use.”",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      26,
      18,
      27,
      44
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 4,
    "question": "What is a hallucination?",
    "choice_a": "When an AI system fails to generate a response.",
    "choice_b": "When AI generates a response that is slow.",
    "choice_c": "When AI creates false or misleading information.",
    "choice_d": "When the AI system has reached the limit for processing data.",
    "correct_answer": "C",
    "explanation": "A hallucination is where an AI system generates false or misleading responses. This is due to the complexities of the transformer model and the quality of the underlying dataset. For more information, see Chapter 1, “The Fundamentals of AI and Its Responsible Use.”",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      17,
      9,
      26,
      20,
      19
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 5,
    "question": "What is required for using GitHub Copilot in VS Code?",
    "choice_a": "An encryption key.",
    "choice_b": "A GitHub account and the Copilot extension.",
    "choice_c": "A paid subscription only.",
    "choice_d": "A Docker container.",
    "correct_answer": "B",
    "explanation": "Before you can use GitHub Copilot in VS Code, you need a GitHub account—which can be the free version—and the Copilot extension, which is available in the marketplace. For more information, see Chapter 2, “Introduction to GitHub Copilot.”",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      64,
      62,
      57
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 6,
    "question": "For GitHub Copilot, what is a chat variable?",
    "choice_a": "A way to select an LLM.",
    "choice_b": "A keyboard shortcut.",
    "choice_c": "A way to provide context in a prompt.",
    "choice_d": "A security setting.",
    "correct_answer": "C",
    "explanation": "A chat variable starts with the # character, such as #file or #editor. They provide more context in your prompt, which allows for an improved response. For more information, see Chapter 2, “Introduction to GitHub Copilot.”",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      69,
      67,
      65,
      87,
      66
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 7,
    "question": "Which IDE has the highest degree of integration with GitHub Copilot?",
    "choice_a": "Xcode",
    "choice_b": "Vim",
    "choice_c": "JetBrains",
    "choice_d": "VS Code",
    "correct_answer": "D",
    "explanation": "With VS Code, you get the most up-to-date version of GitHub Copilot. This is the recommended IDE for this tool. For more information, see Chapter 2, “Introduction to GitHub Copilot.”",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      64,
      57,
      102,
      65,
      67
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 8,
    "question": "In GitHub Copilot Chat, what does @workspace do?",
    "choice_a": "Connects to your Git history.",
    "choice_b": "Creates the files for a new project.",
    "choice_c": "Analyzes the structure of your project’s code.",
    "choice_d": "Allows for using AI in the terminal window.",
    "correct_answer": "C",
    "explanation": "The @workspace is what you use in a prompt. It references the structure and code files in your project. This helps generate better suggestions, explanations, and code. For more information, see Chapter 2, “Introduction to GitHub Copilot.”",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      67,
      65,
      69,
      68,
      64
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 9,
    "question": "What do you need to use the Enterprise version of GitHub Copilot?",
    "choice_a": "The OpenAI API",
    "choice_b": "A GitHub Enterprise Cloud subscription",
    "choice_c": "An organization with a minimum of five seats",
    "choice_d": "The GitHub Copilot REST API",
    "correct_answer": "B",
    "explanation": "To use GitHub Copilot Enterprise, you need the paid GitHub Enterprise Cloud subscription. You cannot use a trial version. For more information, see Chapter 3, “Differences in GitHub Copilot Versions.”",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      97,
      57,
      102,
      62,
      92
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 10,
    "question": "When using GitHub Copilot, what happens if a suggestion matches public code?",
    "choice_a": "It is deleted.",
    "choice_b": "The code is sent to the GitHub Security Hub.",
    "choice_c": "A notification is shown with license information.",
    "choice_d": "There is an automatic security review.",
    "correct_answer": "C",
    "explanation": "If the generated code from GitHub Copilot matches public code—such as from a repository—you will be notified. There will be information about the source and license details. For more information, see Chapter 3, “Differences in GitHub Copilot Versions.”",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      228,
      88,
      102,
      57
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 11,
    "question": "What is a reason to use the GitHub Copilot REST API?",
    "choice_a": "To build mobile backends.",
    "choice_b": "To use third-party extensions.",
    "choice_c": "To configure security notifications.",
    "choice_d": "To automate seat and policy management.",
    "correct_answer": "D",
    "explanation": "The REST API is available for the Business and Enterprise editions. It allows for automating tasks, such for managing user seats and retrieving usage data. For more information, see Chapter 3, “Differences in GitHub Copilot Versions.”",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      92,
      102,
      57,
      93,
      97
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 12,
    "question": "What is the main reason to use slash commands in GitHub Copilot?",
    "choice_a": "To delete code from a code file.",
    "choice_b": "To customize AI models.",
    "choice_c": "To give instructions in Chat.",
    "choice_d": "To manage billing and subscriptions.",
    "correct_answer": "C",
    "explanation": "Slash commands are short instructions you use in Chat, such as to generate, debug or explain code. For more information, see Chapter 3, “Differences in GitHub Copilot Versions.”",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      66,
      65,
      87,
      69,
      67
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 13,
    "question": "How does telemetry data help GitHub Copilot?",
    "choice_a": "It helps with authentication.",
    "choice_b": "It improves code quality by matching similar code repositories.",
    "choice_c": "It provides user feedback.",
    "choice_d": "It is used to select an AI model.",
    "correct_answer": "C",
    "explanation": "Telemetry data is information about what suggestions users accept or reject. This data is used to improve the AI models. For more information, see Chapter 4, “The Role of Data.”",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      120,
      111,
      123
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 14,
    "question": "What is the purpose of the safety filter in GitHub Copilot?",
    "choice_a": "To check for security risks and responsible AI practices.",
    "choice_b": "To identify syntax errors.",
    "choice_c": "To fix logic errors.",
    "choice_d": "To add error handling to code.",
    "correct_answer": "A",
    "explanation": "The safety filter in GitHub Copilot is used to identify risky code and to ensure responsible AI guidelines. For more information, see Chapter 4, “The Role of Data.”",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      123
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 15,
    "question": "What is a disadvantage of GitHub Copilot’s context window?",
    "choice_a": "It limits the number of suggestions each month.",
    "choice_b": "It can only be used with OpenAI models.",
    "choice_c": "It only works with Python.",
    "choice_d": "It can only process a certain amount of code at one time.",
    "correct_answer": "D",
    "explanation": "The AI models used in GitHub Copilot have context windows. This means that these systems can only analyze a limited amount of code at a time. For more information, see Chapter 4, “The Role of Data.”",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      127,
      123,
      111
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 16,
    "question": "How does GitHub Copilot gather context for code suggestions?",
    "choice_a": "By accessing similar GitHub repositories.",
    "choice_b": "By requiring uploading files into GitHub Copilot.",
    "choice_c": "By analyzing the active file, related files, and metadata.",
    "choice_d": "By using telemetry data.",
    "correct_answer": "C",
    "explanation": "Context provides more information for a prompt, so as to generate a better response. GitHub will collect data from the current file, other open tabs, and use metadata. For more information, see Chapter 4, “The Role of Data.”",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      123,
      120,
      127
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 17,
    "question": "Why might a prompt generate a poor response from GitHub Copilot?",
    "choice_a": "There is not a reference to a coding style guide.",
    "choice_b": "The prompt is too short.",
    "choice_c": "The prompt is too vague or confusing.",
    "choice_d": "The prompt does not use slash commands.",
    "correct_answer": "C",
    "explanation": "Generally, prompts need to be clear and provide enough context. If not, the AI system can misunderstand what is being asked. For more information, see Chapter 5, “Prompt Crafting and Engineering.”",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      141,
      135,
      139,
      140,
      143
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 18,
    "question": "Which programming language options are available for GitHub Copilot?",
    "choice_a": "GitHub Copilot only works with Python, JavaScript, and Java.",
    "choice_b": "GitHub Copilot supports many programming languages from its training data.",
    "choice_c": "GitHub Copilot requires uploading programming language modules.",
    "choice_d": "GitHub Copilot only allows for scripting languages.",
    "correct_answer": "B",
    "explanation": "GitHub has not disclosed the number of languages supported. But there are, nonetheless, many supported. The reason is that they are based on large amounts of public repositories. For more information, see Chapter 5, “Prompt Crafting and Engineering.”",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      159
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 19,
    "question": "In what way does GitHub Copilot use Chat history for generating responses?",
    "choice_a": "It only looks at the last Chat response.",
    "choice_b": "It does not use the Chat history.",
    "choice_c": "It uses the Chat history to improve the accuracy and relevance of the response.",
    "choice_d": "It archives it to a repository for compliance purposes.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot uses the Chat history as a way to better understand the context of a prompt. This should help provide more accurate and useful responses. For more information, see Chapter 5, “Prompt Crafting and Engineering.”",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      139,
      140,
      143,
      141
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 20,
    "question": "For the prompt process flow in GitHub Copilot, what follows after analyzing the context?",
    "choice_a": "The LLM generates code snippets.",
    "choice_b": "The system generates a user feedback report.",
    "choice_c": "A different AI model is used.",
    "choice_d": "A prompt is formed using context, recent edits, and Chat history.",
    "correct_answer": "D",
    "explanation": "Once GitHub Copilot has gathered the context, it will create a prompt that includes information such as code, edits, and Chat history. For more information, see Chapter 5, “Prompt Crafting and Engineering.”",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      139,
      140,
      144,
      141,
      142
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 21,
    "question": "What is the purpose of decomposing conditionals when refactoring code with GitHub Copilot?",
    "choice_a": "To delete legacy logic.",
    "choice_b": "To convert code to another language.",
    "choice_c": "To break down complex decisions into smaller functions.",
    "choice_d": "To make the code optimized for mobile devices.",
    "correct_answer": "C",
    "explanation": "The decomposing of conditions is about splitting large decision blocks into smaller, clearer functions. This helps improve readability and maintainability of the code. For more information, see Chapter 6, “Developer Use Cases for GitHub Copilot.”",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      174
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 22,
    "question": "How can GitHub Copilot generate sample data?",
    "choice_a": "By connecting to a third-party relational database.",
    "choice_b": "By using a custom AI model.",
    "choice_c": "By importing data from government sites.",
    "choice_d": "By using a prompt to generate realistic test data like user IDs and passwords.",
    "correct_answer": "D",
    "explanation": "GitHub Copilot can generate realistic sample data, such as test usernames and passwords. You can also do this in formats like JSON or CSV. For more information, see Chapter 6, “Developer Use Cases for GitHub Copilot.”",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      179,
      182,
      180
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 23,
    "question": "In what way does GitHub Copilot reduce the problem of context switching for developers?",
    "choice_a": "It removes all project dependencies.",
    "choice_b": "It stores full system logs automatically.",
    "choice_c": "It integrates directly into code editors like VS Code and JetBrains.",
    "choice_d": "It blocks external API calls.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot reduces context switching by providing in-editor code suggestions and explanations. This helps developers stay focused on their work. For more information, see Chapter 6, “Developer Use Cases for GitHub Copilot.”",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      196,
      168,
      174,
      175,
      173
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 24,
    "question": "Which of the following is a way to generate tests using GitHub Copilot?",
    "choice_a": "Use the /unittest slash command.",
    "choice_b": "Ask GitHub Copilot to run the code automatically.",
    "choice_c": "Use the /tests slash command or custom prompts.",
    "choice_d": "Install a third-party plugin for testing.",
    "correct_answer": "C",
    "explanation": "For creating tests, you can use the /tests slash command or create a custom prompt, which can provide more detail. For more information, see Chapter 7, “Testing and Privacy Considerations.”",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      205,
      201,
      200
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 25,
    "question": "How can GitHub Copilot help with writing assertions in a test?",
    "choice_a": "By suggesting appropriate assertion statements based on the function’s behavior.",
    "choice_b": "By using a testing library.",
    "choice_c": "By creating random outputs.",
    "choice_d": "By using a third-party extension.",
    "correct_answer": "A",
    "explanation": "GitHub Copilot will analyze the code, so as to detect the patterns. From this, it will generate assertion statements to test a function’s expected output. For more information, see Chapter 7, “Testing and Privacy Considerations.”",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      205,
      201,
      200
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 26,
    "question": "Which of the following is a security best practice that GitHub Copilot might recommend?",
    "choice_a": "Using fewer functions in your code.",
    "choice_b": "Storing passwords in plain text for easier debugging.",
    "choice_c": "Validating user input to prevent injection attacks.",
    "choice_d": "Removing error messages from logs.",
    "correct_answer": "C",
    "explanation": "When you do a code review, GitHub Copilot will provide suggestions based on security best practices, such as validating user inputs to prevent vulnerabilities like injection attacks. For more information, see Chapter 7, “Testing and Privacy Considerations.”",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      207
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 27,
    "question": "What is an impact of allowing content exclusions at the organization level in GitHub Copilot Enterprise?",
    "choice_a": "It prevents selected files or paths from being used to generate Copilot suggestions.",
    "choice_b": "It removes private repositories from GitHub.",
    "choice_c": "It disables Copilot suggestions.",
    "choice_d": "It forces all repositories to become read-only.",
    "correct_answer": "A",
    "explanation": "When you set content exclusions at the organization level, GitHub Copilot will be restricted from using specific files or directories when generating code suggestions. This helps improve security and privacy. For more information, see Chapter 7, “Testing and Privacy Considerations.”",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      218,
      217,
      219
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 28,
    "question": "What is the purpose of the duplication detector filter in GitHub Copilot?",
    "choice_a": "To provide disaster recovery if there is a failure.",
    "choice_b": "To detect and block suggestions that closely match public code.",
    "choice_c": "To run code performance benchmarks.",
    "choice_d": "To remove comments from the code.",
    "correct_answer": "B",
    "explanation": "In GitHub Copilot, the duplication detector will filter for identical or nearly identical code from public repositories. This helps avoid intellectual property infringement. For more information, see Chapter 7, “Testing and Privacy Considerations.”",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      219,
      217,
      218
    ],
    "source": "349982_Assessment Test"
  },
  {
    "id": 29,
    "question": "Which of the following best describes how AI coding systems impact software development?",
    "choice_a": "AI coding systems completely eliminate the need for programming knowledge.",
    "choice_b": "AI coding systems only generate syntax-correct code without logical errors.",
    "choice_c": "AI coding systems generate code but may introduce security vulnerabilities and inefficiencies.",
    "choice_d": "AI coding tools require no human intervention once deployed.",
    "correct_answer": "C",
    "explanation": "AI coding systems have revolutionized software development. But they have clear drawbacks too. These tools can generate code with security vulnerabilities like SQL injections or buffer overflows. They may also create bloated code. Because of the issues, developers should always review code generated by AI coding systems.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      19,
      20,
      37,
      44,
      27
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 30,
    "question": "Which machine learning technique is used for training a model with labeled data?",
    "choice_a": "Reinforcement learning",
    "choice_b": "Supervised learning",
    "choice_c": "Unsupervised learning",
    "choice_d": "Deep learning",
    "correct_answer": "B",
    "explanation": "Supervised learning is a machine learning technique that uses labeled data. This means that each training example includes both input data and the correct output. This allows an algorithm to learn from the dataset by mapping the inputs to the outputs.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      7
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 31,
    "question": "You are using GitHub Copilot and you want to select an AI model for the code generation. Which benchmark would be most relevant to evaluate its performance?",
    "choice_a": "SWE-bench",
    "choice_b": "ImageNet",
    "choice_c": "BERTScore",
    "choice_d": "Turing Test",
    "correct_answer": "A",
    "explanation": "The SWE-bench (Software Engineering Benchmark) is tailored for evaluating the performance of AI models for software development. The other benchmarks mentioned in the answers are for other use cases. For example, ImageNet is for computer vision and the BERTScore is for language understanding. As for the Turing test, it is not a benchmark. It is instead a general test to gauge if a system is AI.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      34,
      1,
      38,
      7,
      9
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 32,
    "question": "What is a key security risk when using code that’s generated by AI?",
    "choice_a": "AI-generated code is always encrypted, making it hard to debug.",
    "choice_b": "AI-generated code may have threats like SQL injections and buffer overflows.",
    "choice_c": "AI-generated code usually has hardcoded passwords.",
    "choice_d": "AI-generated code is automatically reviewed for security threats.",
    "correct_answer": "B",
    "explanation": "Generally, AI-generated code is secure. But there can still be vulnerabilities. Examples include SQL injections, buffer overflows, and cross-site scripting threats. The reason for these dangers is that the underlying training data may suffer from insecure practices. As a result, developers should do a security review of their AI-generated code.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      19,
      27,
      26,
      44,
      20
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 33,
    "question": "You are building a recommendation system for an ecommerce platform. Which machine learning technique is best for this task?",
    "choice_a": "Supervised learning",
    "choice_b": "Reinforcement learning",
    "choice_c": "Unsupervised learning",
    "choice_d": "Deep learning",
    "correct_answer": "C",
    "explanation": "Generally, a recommendation system will use unsupervised learning. This would include clustering algorithms. For example, they would find patterns in the unlabeled data.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      7
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 34,
    "question": "What is a common reason why AI-generated code may be difficult to maintain?",
    "choice_a": "It is always too cryptic to understand.",
    "choice_b": "It may be verbose, redundant, or inconsistent in variable naming.",
    "choice_c": "It follows detailed coding standards that are hard to modify.",
    "choice_d": "It is written in an entirely new programming language.",
    "correct_answer": "B",
    "explanation": "Sometimes AI-generated code can be bloated. It could have unnecessary steps, inconsistent variables names, and redundant logic or functions. Bloated code can be difficult to maintain and update. This is why there needs to be refactoring of AI-generated code.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      20,
      37,
      17
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 35,
    "question": "Which of the following is a major limitation of generative AI models like ChatGPT for software development?",
    "choice_a": "They cannot generate code for widely used programming languages.",
    "choice_b": "They only work for frontend development tasks.",
    "choice_c": "They may create hallucinations.",
    "choice_d": "They cannot generate code for frameworks.",
    "correct_answer": "C",
    "explanation": "A major limitation of AI models is that they can create hallucinations. These are the result of poor quality of the dataset and the probabilistic nature of the transformer model. Sometimes, the code is incorrect. In other cases, it may work but not do what was intended.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      17,
      9,
      20,
      19,
      21
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 36,
    "question": "Which of the following is an example of reinforcement learning?",
    "choice_a": "Training a chatbot using labeled data",
    "choice_b": "A model for a self-driving car that learns to navigate by receiving rewards for correct movements",
    "choice_c": "An AI model that uses unlabeled data for clustering",
    "choice_d": "A deep learning model that processes medical images for disease detection",
    "correct_answer": "B",
    "explanation": "Reinforcement learning is a machine learning (ML) technique. It is where a system learns by interacting with an environment. With an AI model for a self-driving car, it can improve its navigation by getting rewarded for positive results, like avoiding obstacles or staying on the right side of the road. By the same token, there can penalties for negative results like deviating from a lane.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      7
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 37,
    "question": "What is one reason multimodal AI coding systems are becoming more popular?",
    "choice_a": "They allow users to select different AI models based on their requirements.",
    "choice_b": "They eliminate the need for debugging AI-generated code.",
    "choice_c": "They allow for supervised learning.",
    "choice_d": "They are trained exclusively on proprietary datasets.",
    "correct_answer": "A",
    "explanation": "Multimodel AI coding systems give users the option to choose from multiple AI models, such as OpenAI’s GPT, Anthropic’s Claude, and Google’s Gemini. Different models have varying strengths in code generation, reasoning, and problem-solving. A developer can experiment with the models to see which ones work for a particular task. They can also use benchmarks to evaluate the AI models.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      34,
      38,
      1
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 38,
    "question": "Why is fine-tuning a large language model (LLM) more difficult than using retrieval augmented generation (RAG)?",
    "choice_a": "Fine-tuning requires specialized data science expertise.",
    "choice_b": "Fine-tuning is always less accurate than RAG.",
    "choice_c": "Fine-tuning does not allow customization of LLMs.",
    "choice_d": "Fine-tuning can only be done using open-source models.",
    "correct_answer": "A",
    "explanation": "Fine-tuning an LLM involves modifying the model’s parameters. This is done by training it on a new dataset. However, this is a complicated process that requires skilled data scientists. RAG, on the other hand, is a much simpler process. It uses a search algorithm that is connected to a dataset.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      17,
      21,
      8,
      7
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 39,
    "question": "A financial services company is using generative AI for its customer support system. What is a key risk if there is no human oversight?",
    "choice_a": "AI-generated responses will be too long.",
    "choice_b": "AI may generate misinformation.",
    "choice_c": "AI will be too expensive.",
    "choice_d": "AI eliminates the need for human customer support agents.",
    "correct_answer": "B",
    "explanation": "Generative AI models can generate hallucinations. This is where the information may seem correct but is actually misleading or false.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      26,
      27,
      19,
      44
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 40,
    "question": "Why is it important to test an AI system for fairness before using it for hiring decisions?",
    "choice_a": "To ensure all candidates receive equal treatment regardless of demographics.",
    "choice_b": "To increase the AI system’s speed in processing applications.",
    "choice_c": "To minimize the cost of hiring human recruiters.",
    "choice_d": "To guarantee that the AI model replaces all human decision-making.",
    "correct_answer": "A",
    "explanation": "If an AI model is trained on biased dataset, then this can lead to unintentional discrimination. With fairness—which is a principle of responsible AI—this can be identified and mitigated.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      18,
      26,
      27,
      44
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 41,
    "question": "A company is using AI to produce marketing copy. However, it is generating output that perpetuates stereotypes. What is the best approach to address this problem?",
    "choice_a": "Increase the model’s training data size without modifying its content.",
    "choice_b": "Implement bias detection tools and adjust training data for diversity.",
    "choice_c": "Block all AI-generated content from being used in marketing.",
    "choice_d": "Reduce the AI’s processing power to minimize bias.",
    "correct_answer": "B",
    "explanation": "AI models can reflect biases in their training datasets. But there are ways to handle this, such as with bias detection tools and retraining the model with diverse and representative data.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      18,
      26,
      27,
      44
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 42,
    "question": "Which of the following is a key responsibility of an AI ethics team within an organization?",
    "choice_a": "Ensuring that AI models always generate content at maximum speed",
    "choice_b": "Conducting periodic audits to identify ethical risks in AI models",
    "choice_c": "Developing AI tools without regulatory oversight",
    "choice_d": "Making AI the sole decision-maker in all business operations",
    "correct_answer": "B",
    "explanation": "AI ethics teams are key for monitoring and mitigating ethical risks. They help detect bias and privacy issues. They should also have periodic audits to provide for responsible AI.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      27,
      18,
      26,
      44,
      19
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 43,
    "question": "A company wants to use AI-generated recommendations for its loan approvals. What should be a key concern when deploying this system?",
    "choice_a": "Ensuring the AI consistently approves high-dollar amount loans",
    "choice_b": "Making sure the AI model follows ethical and regulatory compliance guidelines",
    "choice_c": "Using the AI model to eliminate human oversight in loan approvals",
    "choice_d": "Optimizing the AI to increase the number of loans processed per day",
    "correct_answer": "B",
    "explanation": "AI in financial in the financial services industry is highly regulated. When it uses this technology, it needs to meet rigorous legal, ethical, and compliance requirements. There should also be periodic audits.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      26,
      27,
      18,
      44
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 44,
    "question": "Which of the following is a major privacy risk when using generative AI to process user data in a chatbot?",
    "choice_a": "AI models will automatically anonymize user data before processing it.",
    "choice_b": "AI-generated outputs may reveal sensitive user information.",
    "choice_c": "AI removes the need for data protection policies and compliance measures.",
    "choice_d": "AI models never store or process personal data.",
    "correct_answer": "B",
    "explanation": "AI models trained on user data can sometimes generate responses that unintentionally expose personal or confidential information. This is due to the complex nature of the underlying AI algorithms. This why it’s important to implement strong privacy policies.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      27,
      26,
      17,
      19,
      44
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 45,
    "question": "Why are reliability and safety important in AI systems?",
    "choice_a": "AI systems must be able to adapt to unexpected situations and function as intended.",
    "choice_b": "AI should always replace human decision-making.",
    "choice_c": "AI does not require testing because it always produces accurate results.",
    "choice_d": "AI models are inherently safe and do not require monitoring.",
    "correct_answer": "A",
    "explanation": "AI systems should undergo extensive testing and monitoring. This will help ensure reliability. This is especially important for critical applications, such as for finance and healthcare.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      26,
      27,
      19,
      44,
      17
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 46,
    "question": "How does inclusiveness improve AI systems?",
    "choice_a": "It speeds up AI response times.",
    "choice_b": "It allows AI to replace human interactions completely.",
    "choice_c": "It increases the AI’s ability to make biased decisions.",
    "choice_d": "It ensures AI systems can serve diverse populations, such as people with disabilities.",
    "correct_answer": "D",
    "explanation": "Inclusiveness ensures that AI systems are designed to be accessible and beneficial for all. This includes individuals with disabilities.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      27,
      26,
      18
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 47,
    "question": "Why is transparency a benefit for AI systems?",
    "choice_a": "It allows AI developers to keep their methods confidential.",
    "choice_b": "It ensures AI makes decisions without any human involvement.",
    "choice_c": "It helps users understand how AI makes decisions and detect potential biases.",
    "choice_d": "It removes the need for AI testing.",
    "correct_answer": "C",
    "explanation": "Transparency helps to improve trust in AI systems. This is done by making the decision-making processes understandable and explainable to users.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      27,
      26,
      18,
      19,
      44
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 48,
    "question": "How can AI developers ensure accountability in AI systems?",
    "choice_a": "Rely solely on AI-generated reports to assess ethical concerns",
    "choice_b": "Implement clear policies and industry standards",
    "choice_c": "Allow only executives to review AI decisions without technical input",
    "choice_d": "Assume that AI systems will naturally align with ethical standards over time",
    "correct_answer": "B",
    "explanation": "Accountability ensures AI systems operate responsibly. For this, it’s important to set forth clear policies with ethical guidelines.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      27,
      26,
      44,
      18,
      19
    ],
    "source": "349982_Ch01"
  },
  {
    "id": 49,
    "question": "What is a key advantage for developers when using GitHub Copilot?",
    "choice_a": "It replaces the need for manual testing of code.",
    "choice_b": "It automatically refactors all code without developer input.",
    "choice_c": "It provides real-time code suggestions based on the context.",
    "choice_d": "It eliminates the need for version control systems.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot provides real-time code suggestions based on the context. It does not replace manual testing, version control, or perform automatic refactoring without input.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      70,
      46,
      47,
      65,
      84
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 50,
    "question": "How does GitHub Copilot improve developer productivity?",
    "choice_a": "It replaces the need for manual testing of code.",
    "choice_b": "By reducing the time spent on repetitive coding tasks.",
    "choice_c": "By enforcing a fixed coding style for all projects.",
    "choice_d": "By automating software deployment to production servers.",
    "correct_answer": "B",
    "explanation": "Various studies highlight that GitHub Copilot helps developers complete tasks faster. This is especially true for tasks that are repetitive and tedious. This means developers have more time to focus on problem solving.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      46,
      53,
      84,
      47,
      48
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 51,
    "question": "Which GitHub Copilot plan is best for large organizations that require strong security and compliance capabilities?",
    "choice_a": "GitHub Copilot Free",
    "choice_b": "GitHub Copilot Individual",
    "choice_c": "GitHub Copilot Business",
    "choice_d": "GitHub Copilot Enterprise",
    "correct_answer": "D",
    "explanation": "Copilot Enterprise includes advanced security, compliance features, and integration with enterprise-grade environments. This is the best fit for large organizations.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      57,
      102,
      97,
      93,
      98
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 52,
    "question": "What is the role of GitHub Copilot Chat in the development process?",
    "choice_a": "It automates deployment pipelines for cloud-based applications.",
    "choice_b": "It provides interactive, context-aware assistance within the IDE.",
    "choice_c": "It replaces the need for human developers in software projects.",
    "choice_d": "It automatically merges pull requests without review.",
    "correct_answer": "B",
    "explanation": "GitHub Copilot Chat helps developers by offering context-aware suggestions, explanations, and debugging support. This helps improve the efficiency of coding workflows.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      65,
      47,
      67,
      69,
      66
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 53,
    "question": "Which of the following is a correct way to activate GitHub Copilot’s inline suggestions?",
    "choice_a": "Using specialized GitHub Job Actions",
    "choice_b": "Typing a comment or starting a code snippet",
    "choice_c": "Opening the Copilot CLI tool",
    "choice_d": "Manually exporting the code to Copilot Chat",
    "correct_answer": "B",
    "explanation": "GitHub Copilot automatically suggests inline completions when developers type comments or begin a code snippet. This helps make coding faster and more efficient.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      70,
      64,
      65,
      69,
      47
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 54,
    "question": "What is one reason GitHub Copilot helps with full-stack development?",
    "choice_a": "It generates UI and backend code across multiple programming languages.",
    "choice_b": "It eliminates the need to manually configure core cloud infrastructure.",
    "choice_c": "It fully automates all aspects of frontend and backend development.",
    "choice_d": "It ensures all generated code is free from security vulnerabilities.",
    "correct_answer": "A",
    "explanation": "GitHub Copilot supports multiple programming languages. As a result, it can help with both frontend and backend development. But this does not replace manual configuration or guarantee security.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      47,
      46,
      70,
      53,
      84
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 55,
    "question": "How does GitHub Copilot help developers with learning a new programming language?",
    "choice_a": "By automatically translating Java code into Python and vice versa.",
    "choice_b": "By providing code completions with explanations when developers prompt for help.",
    "choice_c": "By enforcing strict rules to prevent syntax errors.",
    "choice_d": "By preventing developers from using old programming methods.",
    "correct_answer": "B",
    "explanation": "GitHub Copilot can generate code in a requested language and provide explanations. This makes it an effective tool for learning new programming concepts.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      47,
      65,
      70,
      69,
      46
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 56,
    "question": "What is one common disadvantage of using GitHub Copilot?",
    "choice_a": "It does not have third-party integrations.",
    "choice_b": "It requires developers to use only Microsoft Visual Studio Code.",
    "choice_c": "It produces code that requires manual validation for accuracy and security.",
    "choice_d": "It replaces the need for human developers in software engineering.",
    "correct_answer": "C",
    "explanation": "While GitHub Copilot helps to improve productivity, developers must manually validate generated code to ensure it meets functional and security requirements.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      55,
      46,
      47,
      84,
      53
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 57,
    "question": "A developer wants to use GitHub Copilot in the command line. What must they do first?",
    "choice_a": "Install the GitHub CLI and authenticate their account",
    "choice_b": "Disable GitHub Copilot in the IDE",
    "choice_c": "Manually download the Copilot AI model for offline use",
    "choice_d": "Configure GitHub Copilot to run only on private repositories",
    "correct_answer": "A",
    "explanation": "To use GitHub Copilot in the CLI, developers must install the GitHub CLI, authenticate their GitHub account, and enable the Copilot extension.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      74,
      64,
      57,
      102,
      62
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 58,
    "question": "Which of the following is a way to improve GitHub Copilot Chat performance?",
    "choice_a": "Limiting interactions to only ten per day",
    "choice_b": "Using clear prompts",
    "choice_c": "Avoiding the use of slash commands",
    "choice_d": "Using only single-word prompts",
    "correct_answer": "B",
    "explanation": "Providing clear prompts helps GitHub Copilot generate more accurate and relevant responses.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      65,
      67,
      69,
      66,
      88
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 59,
    "question": "A developer wants GitHub Copilot to generate test cases for their code. Which feature should they use?",
    "choice_a": "GitHub Actions",
    "choice_b": "The /test slash command in Copilot Chat",
    "choice_c": "The .copilotignore file",
    "choice_d": "The GitHub Enterprise API",
    "correct_answer": "B",
    "explanation": "The /test slash command prompts GitHub Copilot to generate test cases for the given code.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      66,
      65,
      69,
      87,
      67
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 60,
    "question": "What is the role of slash commands in GitHub Copilot Chat?",
    "choice_a": "They provide a shorthand way to trigger specific AI responses.",
    "choice_b": "They allow Copilot to edit GitHub repository settings.",
    "choice_c": "They enable direct communication with GitHub support.",
    "choice_d": "They disable Copilot’s AI suggestions.",
    "correct_answer": "A",
    "explanation": "Slash commands like /test and /fix help developers quickly perform tasks like generating test cases and debugging.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      66,
      87,
      65,
      69,
      67
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 61,
    "question": "A developer wants to set up GitHub Copilot in Visual Studio Code. What is the first step?",
    "choice_a": "Manually downloading the AI model",
    "choice_b": "Installing the GitHub Copilot extension from the VS Code Marketplace",
    "choice_c": "Disabling version control integration",
    "choice_d": "Configuring .copilotignore before installation",
    "correct_answer": "B",
    "explanation": "To use GitHub Copilot in VS Code, developers must first install the extension from the VS Code Marketplace.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      64,
      62,
      102
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 62,
    "question": "What is one major limitation of GitHub Copilot?",
    "choice_a": "It only works with Microsoft programming languages.",
    "choice_b": "It may generate code that contains security vulnerabilities.",
    "choice_c": "It prevents developers from using external libraries.",
    "choice_d": "It requires all projects to be public.",
    "correct_answer": "B",
    "explanation": "GitHub Copilot generates code based on training data. While it can improve productivity, it may also introduce security vulnerabilities that require manual review.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      55,
      46,
      93,
      84
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 63,
    "question": "Which action can improve GitHub Copilot’s performance when generating code suggestions?",
    "choice_a": "Using precise and well-structured comments in the code",
    "choice_b": "Limiting GitHub Copilot to only one programming language",
    "choice_c": "Running the AI model in offline mode",
    "choice_d": "Disabling the inline suggestion feature",
    "correct_answer": "A",
    "explanation": "Providing clear comments and structure helps GitHub Copilot generate more relevant and high-quality code suggestions.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      70,
      65,
      69,
      47,
      46
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 64,
    "question": "Which command allows developers to use GitHub Copilot in the CLI?",
    "choice_a": "copilot start",
    "choice_b": "gh copilot chat",
    "choice_c": "copilot run",
    "choice_d": "git enable-copilot",
    "correct_answer": "B",
    "explanation": "The gh copilot chat command enables GitHub Copilot Chat in the CLI. This allows developers to use the AI assistant from the terminal.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      74
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 65,
    "question": "A developer wants GitHub Copilot to explain an error message in the terminal. Which command should they use?",
    "choice_a": "gh copilot explain \"error message\"",
    "choice_b": "git error --fix",
    "choice_c": "copilot debug --show-details",
    "choice_d": "cli copilot read-error",
    "correct_answer": "A",
    "explanation": "The gh copilot explain command allows GitHub Copilot to provide explanations for error messages in the terminal.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      74
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 66,
    "question": "What is a key advantage of using GitHub Copilot’s inline chat feature?",
    "choice_a": "It allows developers to get AI-generated suggestions without leaving their code editor.",
    "choice_b": "It automatically merges pull requests based on AI analysis.",
    "choice_c": "It eliminates the need for manual debugging.",
    "choice_d": "It enables AI-driven deployment automation.",
    "correct_answer": "A",
    "explanation": "Inline chat provides contextual AI assistance directly within the IDE. This allows developers to stay in the flow.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      69,
      65,
      47,
      46,
      66
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 67,
    "question": "What is a key advantage of using GitHub Copilot’s Edits feature?",
    "choice_a": "It disables manual code editing.",
    "choice_b": "It generates AI-driven deployment strategies.",
    "choice_c": "It automatically resolves merge conflicts.",
    "choice_d": "It allows developers to modify multiple files simultaneously.",
    "correct_answer": "D",
    "explanation": "GitHub Copilot Edits enables developers to make AI-powered modifications across multiple files at once. This can greatly increase productivity.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      71,
      66,
      46,
      47,
      102
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 68,
    "question": "A developer is working on a project and wants GitHub Copilot to suggest improvements to a function. What is a way to accomplish this?",
    "choice_a": "Use the /explain slash command and manually review the function.",
    "choice_b": "Delete the function and rewrite it from scratch.",
    "choice_c": "Disable Copilot’s suggestions and work without AI assistance.",
    "choice_d": "Use the /deploy slash command to optimize the function.",
    "correct_answer": "A",
    "explanation": "The /explain command in GitHub Copilot Chat provides insights into how a function works.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      66,
      65,
      69,
      74,
      64
    ],
    "source": "349982_Ch02"
  },
  {
    "id": 69,
    "question": "Which feature is exclusive to GitHub Copilot Enterprise?",
    "choice_a": "Pull request summaries",
    "choice_b": "Organization-wide policy management",
    "choice_c": "Knowledge bases",
    "choice_d": "Inline code suggestions",
    "correct_answer": "C",
    "explanation": "Knowledge bases are a feature unique to GitHub Copilot Enterprise. They help improve code quality, consistency, and efficiency by storing design patterns, best practices, and reusable code snippets. The other options are available in lower-tier versions as well.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      98,
      102,
      57,
      97,
      99
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 70,
    "question": "Which of the following is a unique feature of GitHub Copilot Business compared to the Individual version?",
    "choice_a": "Centralized billing",
    "choice_b": "Inline code suggestions",
    "choice_c": "Chat integration in the IDE",
    "choice_d": "Pull request summaries",
    "correct_answer": "A",
    "explanation": "GitHub Copilot Business includes centralized billing. This helps streamline payment management for organizations. The Individual version, on the other hand, is meant for personal use, with separate billing for each user.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      57,
      92,
      102,
      93
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 71,
    "question": "What is the main advantage of using custom models in GitHub Copilot Enterprise?",
    "choice_a": "They allow unlimited usage across all repositories.",
    "choice_b": "They provide improved accuracy and efficiency by tailoring the model to organizational coding standards.",
    "choice_c": "They automatically fix syntax errors in code.",
    "choice_d": "They replace the need for knowledge bases.",
    "correct_answer": "B",
    "explanation": "Custom models allow organizations to fine-tune the LLM to their specific coding standards, patterns, and practices. This improves relevance and productivity.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      99,
      102,
      97,
      57,
      46
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 72,
    "question": "How does GitHub Copilot generate pull request summaries?",
    "choice_a": "By comparing the pull request to similar ones in the repository history.",
    "choice_b": "By analyzing the changes and creating a natural language summary.",
    "choice_c": "By running test cases on the modified code and reporting results.",
    "choice_d": "By listing all filenames and code lines changed.",
    "correct_answer": "B",
    "explanation": "GitHub Copilot generates pull request summaries by analyzing the changes made in the pull request and creating a natural language summary. This helps reviewers understand the modifications.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      87,
      72,
      102,
      228
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 73,
    "question": "Which of the following is true about audit logs in GitHub Copilot Business?",
    "choice_a": "They allow developers to view code completion suggestions.",
    "choice_b": "They are only accessible to repository contributors.",
    "choice_c": "They track activities and policy changes for compliance and security.",
    "choice_d": "They automatically assign seats for new team members.",
    "correct_answer": "C",
    "explanation": "Audit logs in GitHub Copilot Business provide a chronological record of activities and changes to settings. This helps with compliance, security, and accountability.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      93,
      102,
      92
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 234,
    "question": "What is a key benefit of using GitHub Copilot Spaces?",
    "choice_a": "Grounding Copilot responses in shared project context and organizational standards.",
    "choice_b": "Restricting Copilot access exclusively to repository contributors.",
    "choice_c": "Automatically detecting and fixing all runtime errors.",
    "choice_d": "Providing unlimited access to every repository.",
    "correct_answer": "A",
    "explanation": "Copilot Spaces bring together curated context such as code, documentation, specifications, and custom instructions. This helps Copilot provide more relevant, project-specific responses and allows teams to share knowledge and development standards.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      98,
      67,
      102,
      97,
      88
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 75,
    "question": "Which GitHub Copilot version supports organization-wide policy management?",
    "choice_a": "Copilot Individual",
    "choice_b": "Copilot Pro",
    "choice_c": "Copilot Business",
    "choice_d": "Copilot Chat",
    "correct_answer": "C",
    "explanation": "Organization-wide policy management is supported in GitHub Copilot Business and Enterprise. This allows organizations to enforce consistent policies across all users.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      92,
      102,
      57,
      93,
      97
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 76,
    "question": "Which of the following is not a feature of GitHub Copilot Individual?",
    "choice_a": "Inline code suggestions",
    "choice_b": "Custom models",
    "choice_c": "Pull request summaries",
    "choice_d": "Slash commands and context variables for prompts",
    "correct_answer": "B",
    "explanation": "Custom models are exclusive to GitHub Copilot Enterprise. They allow organizations to fine-tune AI models to their specific coding practices.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      102,
      99,
      57,
      92,
      88
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 77,
    "question": "How can administrators exclude specific files from GitHub Copilot Business?",
    "choice_a": "By creating a .copilotignore file in each repository.",
    "choice_b": "By removing the files from the repository.",
    "choice_c": "By disabling Copilot for the entire organization.",
    "choice_d": "By adding file paths to the organization’s Copilot settings.",
    "correct_answer": "D",
    "explanation": "Organization administrators can exclude specific files from being accessed by GitHub Copilot by adding the file paths to the organization’s Copilot settings. This prevents Copilot from using the content for code suggestions.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      93,
      102,
      92
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 78,
    "question": "What is a unique feature of GitHub Copilot Enterprise compared to the Business version?",
    "choice_a": "Organization-wide policy management",
    "choice_b": "Knowledge bases for enhanced code completion",
    "choice_c": "Centralized billing for teams",
    "choice_d": "Inline code suggestions with context awareness",
    "correct_answer": "B",
    "explanation": "Knowledge bases are exclusive to GitHub Copilot Enterprise. They provide advanced customization and consistency by storing best practices, design patterns, and reusable code snippets.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      98,
      102,
      57,
      99,
      97
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 79,
    "question": "Which GitHub Copilot version provides IP indemnity for generated code?",
    "choice_a": "Copilot Individual",
    "choice_b": "Copilot Pro",
    "choice_c": "Copilot Business",
    "choice_d": "Copilot Chat",
    "correct_answer": "C",
    "explanation": "IP indemnity is provided in GitHub Copilot Business and Enterprise versions. It provides legal protection against intellectual property claims related to AI-generated code.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      93,
      57,
      102
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 80,
    "question": "In GitHub Copilot Business, how can an administrator manage seat assignments?",
    "choice_a": "Through the IDE settings panel.",
    "choice_b": "Using the GitHub REST API for subscription management.",
    "choice_c": "By creating a .copilotignore file.",
    "choice_d": "By directly editing the repository’s permissions.",
    "correct_answer": "B",
    "explanation": "The GitHub REST API allows administrators to automate seat assignments, manage subscriptions, and track usage metrics in Copilot Business.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      92,
      102,
      57,
      93,
      97
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 81,
    "question": "Which feature in GitHub Copilot helps prevent the use of public code without proper licensing?",
    "choice_a": "Inline code suggestions",
    "choice_b": "Knowledge bases",
    "choice_c": "Public code filter with code referencing",
    "choice_d": "Custom models",
    "correct_answer": "C",
    "explanation": "The public code filter checks AI-generated code against public repositories to avoid potential intellectual property violations by identifying matches and displaying relevant licenses.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      88,
      228,
      93,
      102
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 82,
    "question": "What is a primary use case for the GitHub Copilot REST API?",
    "choice_a": "Automating seat assignments and revocations",
    "choice_b": "Generating pull request summaries",
    "choice_c": "Creating custom models for code completion",
    "choice_d": "Running real-time syntax checks",
    "correct_answer": "A",
    "explanation": "The GitHub Copilot REST API is used for automating subscription management tasks such as assigning and revoking seats, as well as for retrieving usage metrics.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      92,
      102,
      57,
      93
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 83,
    "question": "Which feature is common between GitHub Copilot Business and Enterprise, but not available in Individual?",
    "choice_a": "Custom models",
    "choice_b": "Inline code suggestions",
    "choice_c": "Organization-wide content exclusions",
    "choice_d": "Slash commands for prompts",
    "correct_answer": "C",
    "explanation": "Organization-wide content exclusions are available in both Business and Enterprise versions. They allow administrators to restrict Copilot’s access to specific files for privacy and compliance.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      102,
      93,
      57,
      92,
      97
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 84,
    "question": "How can administrators search for specific events in GitHub Copilot Business audit logs?",
    "choice_a": "By using a .gitignore file in the repository.",
    "choice_b": "By exporting CSV reports from GitHub support.",
    "choice_c": "By querying with filters like event type or date range.",
    "choice_d": "Directly from the IDE’s configuration panel.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot Business allows administrators to filter audit log events by type, date, and user actions. This makes it easier to track policy changes and activities.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      93,
      102,
      92
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 85,
    "question": "Which is a benefit of using pull request summaries in GitHub Copilot?",
    "choice_a": "Automatically resolving merge conflicts.",
    "choice_b": "Generating a natural language overview of code changes.",
    "choice_c": "Providing inline code suggestions without context.",
    "choice_d": "Archiving all previous pull request versions.",
    "correct_answer": "B",
    "explanation": "Pull request summaries in GitHub Copilot provide a natural language overview of code changes. They help reviewers understand modifications more efficiently.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      87,
      72,
      102,
      228,
      46
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 86,
    "question": "What is the purpose of centralized billing in GitHub Copilot Business?",
    "choice_a": "To provide free unlimited repositories.",
    "choice_b": "To allow individual users to manage their own subscriptions.",
    "choice_c": "To enable custom model integration.",
    "choice_d": "To streamline payment management for organizations.",
    "correct_answer": "D",
    "explanation": "Centralized billing allows organizations to manage payments for all team members under a single account. This helps simplify financial administration.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      92,
      57,
      102,
      93,
      97
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 87,
    "question": "Which feature in GitHub Copilot Business helps organizations comply with data privacy regulations?",
    "choice_a": "Inline code suggestions",
    "choice_b": "Organization-wide content exclusions",
    "choice_c": "Real-time syntax error checking",
    "choice_d": "Unlimited repository access",
    "correct_answer": "B",
    "explanation": "Organization-wide content exclusions allow administrators to prevent specific files from being accessed or analyzed by GitHub Copilot. This helps organizations maintain data privacy and compliance with regulations.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      93,
      102,
      57,
      97
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 88,
    "question": "In GitHub Copilot Enterprise, how are knowledge bases created and managed?",
    "choice_a": "By storing markdown files in selected repositories.",
    "choice_b": "By using .copilotignore files in each repository.",
    "choice_c": "Through inline commands in the IDE.",
    "choice_d": "By exporting repository data to an external database.",
    "correct_answer": "A",
    "explanation": "In GitHub Copilot Enterprise, knowledge bases are created by storing relevant markdown files, such as code snippets, best practices, and design patterns, in selected repositories. These are indexed and used to enhance code completion and review.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      98,
      102,
      97,
      99,
      57
    ],
    "source": "349982_Ch03"
  },
  {
    "id": 89,
    "question": "What happens to user input data in GitHub Copilot Individual?",
    "choice_a": "It is stored indefinitely for future model training.",
    "choice_b": "It is shared with vetted third-party developers for feedback.",
    "choice_c": "It is processed in real-time but not stored permanently.",
    "choice_d": "It is encrypted but retrievable by the user.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot processes user input for generating suggestions but does not store it permanently. However, a user can opt in for this. In this case, the data will be used to improve existing models.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      120,
      123,
      117
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 90,
    "question": "What is the role of GitHub Copilot’s proxy service?",
    "choice_a": "To run code in the IDE.",
    "choice_b": "To filter sensitive data before sending it to the AI model.",
    "choice_c": "To increase the speed of code suggestions.",
    "choice_d": "To store previous user inputs for reference.",
    "correct_answer": "B",
    "explanation": "The proxy service helps prevent sensitive data from being exposed before it reaches the AI model.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      117,
      123,
      116
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 91,
    "question": "What factor impacts the relevance of GitHub Copilot’s code suggestions?",
    "choice_a": "The recency and frequency of training data examples.",
    "choice_b": "The number of developers using GitHub Copilot.",
    "choice_c": "The geographic location of the user.",
    "choice_d": "The amount of storage available in the user’s IDE.",
    "correct_answer": "A",
    "explanation": "Copilot prioritizes commonly seen code patterns. This means that the suggestions can be influenced by older or widely used examples.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      127,
      111,
      108
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 92,
    "question": "What security feature does GitHub Copilot provide to detect potential IP violations?",
    "choice_a": "It references generated code against a database of public repositories.",
    "choice_b": "It checks code completions against court opinions.",
    "choice_c": "It discards all long suggestions after they are generated.",
    "choice_d": "It blocks code completions containing certain keywords.",
    "correct_answer": "A",
    "explanation": "GitHub Copilot applies a code referencing filter to notify users. This detects whether the suggested code closely matches publicly available code.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      123
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 93,
    "question": "What is a key difference in processing between GitHub Copilot’s code completion and the Chat feature?",
    "choice_a": "Chat responses generally take longer as they require more comprehensive analysis.",
    "choice_b": "Code completion processes only numerical data, while Chat handles text-based queries.",
    "choice_c": "Chat generates responses automatically, while code completion requires user confirmation.",
    "choice_d": "Code completion is always slower than Chat.",
    "correct_answer": "A",
    "explanation": "GitHub Copilot Chat often processes more complex queries, such as debugging or documentation generation, which usually require more time.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      123
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 94,
    "question": "How does GitHub Copilot handle prompts to improve the accuracy of code suggestions?",
    "choice_a": "It randomly selects previous suggestions from other users.",
    "choice_b": "It scans the entire project repository for related code.",
    "choice_c": "It retrieves previous AI-generated suggestions stored in a database.",
    "choice_d": "It builds prompts by analyzing the code context, comments, and cursor position.",
    "correct_answer": "D",
    "explanation": "Copilot improves accuracy by using in-file context, user comments, and the cursor’s location to generate relevant suggestions.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      123,
      127
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 95,
    "question": "What is a key limitation of GitHub Copilot when performing calculations?",
    "choice_a": "It prioritizes mathematical operations over code completions.",
    "choice_b": "It prevents users from writing mathematical functions.",
    "choice_c": "It lacks a dedicated math engine and relies on training data for numerical reasoning.",
    "choice_d": "It automatically executes calculations before generating code.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot struggles with precise mathematical calculations because it lacks an internal computation engine.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      127
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 96,
    "question": "What impact does the age of an AI model’s training data have on its performance?",
    "choice_a": "Older training data may lead to outdated or less relevant suggestions.",
    "choice_b": "AI models always update their training data automatically.",
    "choice_c": "Older training data is always more reliable than new data.",
    "choice_d": "The age of training data has no effect on model accuracy.",
    "correct_answer": "A",
    "explanation": "AI models rely on preexisting datasets, and if they are not frequently updated, they may lack knowledge of newer technologies, techniques, or best practices.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      127,
      108,
      111
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 97,
    "question": "Why does GitHub Copilot not store user input permanently?",
    "choice_a": "Because storing data permanently is too expensive.",
    "choice_b": "Because GitHub does not use any AI models.",
    "choice_c": "To protect user privacy.",
    "choice_d": "Because it does not have the capability to process real-time inputs.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot processes user inputs in real-time but does not store them permanently. This helps ensure user privacy.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      120,
      117,
      116
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 98,
    "question": "What happens if GitHub Copilot identifies code that matches publicly available code?",
    "choice_a": "It alerts the user and provides details on the matched code and its license.",
    "choice_b": "It automatically deletes the suggestion and does not notify the user.",
    "choice_c": "It replaces the code with a generic placeholder.",
    "choice_d": "It allows the user to continue using the suggestion without notification.",
    "correct_answer": "A",
    "explanation": "GitHub Copilot includes a code referencing filter to notify users when generated code closely resembles public repository content.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      123
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 99,
    "question": "What is a key advantage of GitHub Copilot Chat over traditional code completion?",
    "choice_a": "It can automatically apply changes to an entire repository.",
    "choice_b": "It operates without any cloud-based processing.",
    "choice_c": "It is designed specifically for hardware programming.",
    "choice_d": "It can generate more comprehensive and context-aware explanations.",
    "correct_answer": "D",
    "explanation": "GitHub Copilot Chat is useful for debugging, generating documentation, and providing detailed code explanations beyond simple code completion.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      123,
      116,
      127,
      120,
      117
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 100,
    "question": "What is a key limitation of GitHub Copilot when analyzing large codebases?",
    "choice_a": "It scans the entire repository before generating suggestions.",
    "choice_b": "It requires users to manually submit queries for every suggestion.",
    "choice_c": "It can only process a limited amount of surrounding code at a time.",
    "choice_d": "It cannot work with modern programming languages.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot has a fixed context window. This means it can only analyze a portion of the surrounding code before generating a response. This can potentially lead to less effective code suggestions.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      127,
      123
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 101,
    "question": "What is an important step in GitHub Copilot’s post-processing stage?",
    "choice_a": "Formatting the generated code to align with proper indentation and syntax.",
    "choice_b": "Automatically executing the code to check for errors.",
    "choice_c": "Sending suggestions to other developers for peer review.",
    "choice_d": "Encrypting all suggestions before displaying them to users.",
    "correct_answer": "A",
    "explanation": "Post-processing ensures that GitHub Copilot’s suggestions are properly formatted and free from redundant or syntactically incorrect elements.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      123
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 102,
    "question": "What happens if a developer is using GitHub Copilot in an air-gapped environment?",
    "choice_a": "GitHub Copilot will store all user inputs locally for later processing.",
    "choice_b": "GitHub Copilot will not function since it requires an active Internet connection.",
    "choice_c": "GitHub Copilot will process requests using offline models.",
    "choice_d": "GitHub Copilot will require manual approval for each generated suggestion.",
    "correct_answer": "B",
    "explanation": "GitHub Copilot relies on cloud-based AI models and cannot operate in environments that lack external network access.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      117
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 103,
    "question": "What is a key reason why AI models require high-quality data for training?",
    "choice_a": "To ensure that AI-generated content is more creative than human-written content.",
    "choice_b": "To reduce biases and improve the accuracy of model predictions.",
    "choice_c": "To allow AI models to generate unlimited amounts of synthetic data without human input.",
    "choice_d": "To increase the speed at which AI models process user requests.",
    "correct_answer": "B",
    "explanation": "High-quality data helps AI models make accurate predictions and reduces bias. This helps ensure more reliable outputs.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      127,
      111,
      108
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 104,
    "question": "Why does GitHub Copilot prioritize analyzing the active file’s content when generating suggestions?",
    "choice_a": "To ensure that suggestions remain relevant to the user’s current coding task.",
    "choice_b": "To prevent users from switching between multiple files.",
    "choice_c": "To limit the number of suggestions Copilot provides.",
    "choice_d": "To store the entire project’s data for future suggestions.",
    "correct_answer": "A",
    "explanation": "Copilot focuses on the active file to generate the most contextually relevant code completions.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      123
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 105,
    "question": "What happens if a GitHub Copilot user disables telemetry data collection?",
    "choice_a": "Copilot will stop generating any code suggestions.",
    "choice_b": "The user’s usage data will no longer be collected for analytics and improvements.",
    "choice_c": "The user will lose access to all Copilot features.",
    "choice_d": "The user’s code will be shared publicly instead.",
    "correct_answer": "B",
    "explanation": "Disabling telemetry prevents GitHub from collecting user activity data for performance analysis and product improvement.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      120
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 106,
    "question": "What role does metadata play in GitHub Copilot’s code suggestions?",
    "choice_a": "It automatically saves user-generated code for future reuse.",
    "choice_b": "It determines whether a user is allowed to use Copilot.",
    "choice_c": "It prevents Copilot from generating suggestions for certain programming languages.",
    "choice_d": "It helps provide context for more relevant and accurate completions.",
    "correct_answer": "D",
    "explanation": "Metadata includes information like file paths and programming languages. This helps GitHub Copilot generate suggestions that fit the user’s project.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      123,
      120,
      127
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 107,
    "question": "What is a key security concern when using AI-powered coding assistants like GitHub Copilot?",
    "choice_a": "AI-generated code may unintentionally include vulnerabilities like hardcoded credentials.",
    "choice_b": "AI will eventually replace all human programmers.",
    "choice_c": "AI-generated code is always more secure than human-written code.",
    "choice_d": "AI models require users to submit their personal information.",
    "correct_answer": "A",
    "explanation": "AI-generated code may introduce security risks if it suggests insecure coding practices.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      123,
      117,
      127
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 108,
    "question": "What is one way GitHub Copilot optimizes performance for developers?",
    "choice_a": "By limiting the number of code suggestions per day.",
    "choice_b": "By requiring manual approval for every suggestion.",
    "choice_c": "By forcing users to manually enter their code for processing.",
    "choice_d": "By prioritizing low-latency response times through cloud infrastructure.",
    "correct_answer": "D",
    "explanation": "GitHub Copilot uses optimized cloud resources to ensure fast response times for code completions.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      123,
      116
    ],
    "source": "349982_Ch04"
  },
  {
    "id": 109,
    "question": "For GitHub Copilot, what is the key reason for prompt engineering?",
    "choice_a": "To change to another large language model.",
    "choice_b": "To use multimodal capabilities.",
    "choice_c": "To write clear instructions for the large language model to create the best code or response.",
    "choice_d": "To automate the SLDC process.",
    "correct_answer": "C",
    "explanation": "Prompt engineering is about writing clear instructions for the large language model. It helps provide a guide for creating more accurate and relevant responses.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      141,
      139,
      140,
      143,
      142
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 110,
    "question": "All of the following are parts of a prompt except the following:",
    "choice_a": "Input of context",
    "choice_b": "Format",
    "choice_c": "Code execution",
    "choice_d": "Context",
    "correct_answer": "C",
    "explanation": "The four parts of a prompt are the context, instructions, input of content, and format. Code execution is something that GitHub Copilot cannot do.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      139,
      140
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 111,
    "question": "Why is it a good idea to avoid writing long prompts for GitHub Copilot?",
    "choice_a": "They always result in hallucinations.",
    "choice_b": "The large language model may misinterpret or ignore important details.",
    "choice_c": "They will use copyrighted code.",
    "choice_d": "They will generate responses that are too long.",
    "correct_answer": "B",
    "explanation": "Writing a good prompt is about balancing clarity and sufficient detail. But if there it is too long, the large language model may get “lost in the middle,” ignoring or misinterpreting information details.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      135,
      141,
      139,
      140,
      142
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 112,
    "question": "In what way does few-shot learning improve the responses of GitHub Copilot?",
    "choice_a": "It includes several examples that help guide the large language model.",
    "choice_b": "It changes the underlying parameters of the large language model.",
    "choice_c": "It increases creativity.",
    "choice_d": "It eliminates mistakes.",
    "correct_answer": "A",
    "explanation": "With few-shot learning, you will include a few examples of the types of responses you want. This helps the large language model to better understand the patterns so as to generate higher quality responses.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      143,
      139,
      140,
      142,
      141
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 113,
    "question": "Why is chain-of-thought (CoT) prompting helpful?",
    "choice_a": "It forces a large language model to answer in either yes or no.",
    "choice_b": "It breaks down complex problems into different steps for improved reasoning.",
    "choice_c": "It increases the speed of the response.",
    "choice_d": "It will mean that the response will use the correct programming language.",
    "correct_answer": "B",
    "explanation": "CoT prompting is about using multiple prompts. They are broken down into logical steps. With each one, the focus is on the reasoning of the large language model.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      143,
      144,
      139
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 114,
    "question": "When writing a prompt for GitHub Copilot, what is a potential security risk?",
    "choice_a": "Using verbose prompts",
    "choice_b": "Asking for XML formatted data",
    "choice_c": "Using the large language model to create data",
    "choice_d": "Including personally identifiable information (PII)",
    "correct_answer": "D",
    "explanation": "Since GitHub is open with what you can input as a prompt, there is a risk that you could expose sensitive data, such as names, addresses, and account numbers. You should either avoid this or anonymize the data.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      144
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 115,
    "question": "Even if you write a clear prompt, why might you still get a false response?",
    "choice_a": "You are using the wrong model.",
    "choice_b": "The model does not have enough relevant data.",
    "choice_c": "You have not adjusted the model.",
    "choice_d": "You did not use a custom model.",
    "correct_answer": "B",
    "explanation": "Even though GitHub Copilot is trained on huge amounts of data, there are still gaps. This is especially the case with more obscure programming languages.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      159,
      135,
      144,
      143,
      141
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 116,
    "question": "How is agentic AI likely to change prompt engineering?",
    "choice_a": "The prompts will need to include more details about formatting.",
    "choice_b": "There will be no need for prompts.",
    "choice_c": "The prompts will be shorter.",
    "choice_d": "You will need to rely on prompt libraries.",
    "correct_answer": "C",
    "explanation": "Agentic AI engages in multi-step reasoning. Much of this will be done autonomously. This means that there will be less detailed prompts, such as in specifying steps or how to approach a task. The agentic AI will use its own reasoning and planning capabilities for this.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      160,
      143,
      135
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 117,
    "question": "For code generation, which languages does GitHub Copilot support?",
    "choice_a": "The ten most popular languages",
    "choice_b": "Scripting languages like JavaScript and SQL",
    "choice_c": "Only languages created by Microsoft",
    "choice_d": "A wide variety of languages",
    "correct_answer": "D",
    "explanation": "GitHub Copilot does not support a specific number of languages. But it does support a large number of them. These languages are part of the massive training dataset for the large language model.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      159
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 118,
    "question": "How does zero-shot learning differ from few-shot learning?",
    "choice_a": "Few-shot learning is based on several languages, whereas zero-shot learning is for one language.",
    "choice_b": "Few-shot learning has several examples in a prompt, whereas zero-shot learning has none.",
    "choice_c": "Few-shot learning is for longer code tasks, whereas zero-shot learning is for code snippets.",
    "choice_d": "Few-shot learning is for refactoring code, whereas zero-shot learning is for functions.",
    "correct_answer": "B",
    "explanation": "Zero-short learning is when you prompt GitHub Copilot without using examples. It’s generally the most common way to interact with this tool. But with few-shot learning, you can provide several examples to provide a guide for the large language model to generate better responses.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      143
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 119,
    "question": "What is a drawback when using foreign translation with an LLM?",
    "choice_a": "It cannot translate technical jargon.",
    "choice_b": "It may not pick up on idiomatic expressions and cultural nuances.",
    "choice_c": "It cannot work with code.",
    "choice_d": "It only can be used for three languages.",
    "correct_answer": "B",
    "explanation": "LLMs can translate many languages because of the vast dataset. But it may not necessarily capture idiomatic expressions and cultural nuances. This can lead to a situation where you offend or confuse users.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      139,
      135,
      144
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 120,
    "question": "Why would you use ### in a prompt?",
    "choice_a": "To separate the instructions from the content",
    "choice_b": "To format responses",
    "choice_c": "To refractor code",
    "choice_d": "To debug code",
    "correct_answer": "A",
    "explanation": "This is a delimiter, which separates the instructions from the content. For example, this could be when you summarize information.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      140,
      139,
      141
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 121,
    "question": "Why would you use leading words in a prompt?",
    "choice_a": "To generate more detailed explanations",
    "choice_b": "To change the format of the response",
    "choice_c": "To encourage a certain type of response",
    "choice_d": "To improve debugging",
    "correct_answer": "C",
    "explanation": "With leading words, you can help guide the large language model. This may actually be one or two words, such as a command like CREATE TABLE.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      142,
      139,
      141
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 122,
    "question": "What is a way to reduce hallucinations when writing a prompt?",
    "choice_a": "Write detailed prompts.",
    "choice_b": "Use delimiters.",
    "choice_c": "Use broad language.",
    "choice_d": "Request a clear response, like “Yes” or “No.”",
    "correct_answer": "D",
    "explanation": "Being specific with the type of response can be helpful in mitigating the issues with hallucinations. There are fewer opportunities for the large language model to stray.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      144,
      141,
      140,
      142,
      139
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 123,
    "question": "How does Chat history influence the responses from GitHub Copilot?",
    "choice_a": "They are not used in the processing.",
    "choice_b": "They are used as context to improve the responses.",
    "choice_c": "The instructions are only used for the processing.",
    "choice_d": "This is only used for custom models.",
    "correct_answer": "B",
    "explanation": "This is used to help generate better responses, as well as the cursor position and code edits.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      139,
      143,
      140,
      141
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 124,
    "question": "Which of the following prompts could be written better?",
    "choice_a": "Code an input form.",
    "choice_b": "/explain.",
    "choice_c": "Create a SQL query to list all customers in the database.",
    "choice_d": "Write a Python function that sorts a list of numbers in descending order.",
    "correct_answer": "A",
    "explanation": "This prompt is too vague. For example, it should specify what the form is for as well as the fields. It could be something like: Create a form for a login that has a field for a username and password.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      141,
      139,
      140,
      142,
      143
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 125,
    "question": "What is a disadvantage of chain-of-thought (CoT) prompting?",
    "choice_a": "It can mean less effective debugging.",
    "choice_b": "It cannot be used with the Chat.",
    "choice_c": "It is only available for Python.",
    "choice_d": "It can increase the response time of the LLM.",
    "correct_answer": "D",
    "explanation": "CoT prompting is effective with complex problem solving, which can lead to higher quality responses. However, the extra processing means that the responses can be slower.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      143,
      135
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 126,
    "question": "Which of the following may result in less effective responses from GitHub Copilot?",
    "choice_a": "A prompt that is too precise.",
    "choice_b": "A prompt with multiple instructions.",
    "choice_c": "A prompt that uses some relevant examples.",
    "choice_d": "A prompt that uses delimiters.",
    "correct_answer": "B",
    "explanation": "Generally, it’s better to have one instruction or task for a prompt. This lessens the possibility of GitHub Copilot emphasizing one over the other.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      139,
      135,
      141,
      140,
      142
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 127,
    "question": "Why might you specify a certain role when writing a prompt?",
    "choice_a": "To mitigate creativity of the response",
    "choice_b": "To do code conversion",
    "choice_c": "To provide more context for the LLM",
    "choice_d": "To focus on a certain programming language",
    "correct_answer": "C",
    "explanation": "An example of specifying a role is to start a prompt with something like, You are an expert at programming Python. This provides the LLM with more context to generate a more relevant response.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      139,
      141,
      143,
      142,
      140
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 128,
    "question": "Why do LLMs like those from OpenAI, Google, and Anthropic generate different responses?",
    "choice_a": "This is based on safety filters",
    "choice_b": "This is due to human feedback loops",
    "choice_c": "This is based on the datasets and proprietary algorithms",
    "choice_d": "The responses are deterministic",
    "correct_answer": "C",
    "explanation": "While these models all use the core transformer model, there are variations on the implementation. The datasets are also different.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      135
    ],
    "source": "349982_Ch05"
  },
  {
    "id": 129,
    "question": "In what ways can you use GitHub Copilot to learn a new programming language?",
    "choice_a": "It can write long-form content.",
    "choice_b": "It can only do this using the default model in the system.",
    "choice_c": "It can create personalized examples and explanations.",
    "choice_d": "It can search the Internet for tutorials.",
    "correct_answer": "C",
    "explanation": "You can prompt GitHub Copilot to learn a language. But the explanations can be personalized, based on your experience and use cases.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      163,
      164,
      170,
      168,
      175
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 130,
    "question": "Among these options, which is not a common developer use case for GitHub Copilot?",
    "choice_a": "Getting help with deployment to Azure.",
    "choice_b": "Creating files that have generated code.",
    "choice_c": "Creating data.",
    "choice_d": "Debugging.",
    "correct_answer": "B",
    "explanation": "GitHub Copilot will not create files. You will need to copy and paste the generated code and place it in a file that you created on your system.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      164,
      191,
      179,
      183,
      196
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 131,
    "question": "What is a benefit of using GitHub Copilot to create documentation?",
    "choice_a": "You cannot use the tool for this.",
    "choice_b": "It will use the whole codebase as context.",
    "choice_c": "It will add images.",
    "choice_d": "It can generate documentation for an API that’s in a Markdown format.",
    "correct_answer": "D",
    "explanation": "With GitHub Copilot, you can specify the files of an API to generate documentation. It can also be done in different formats, like Markdown.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      168
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 132,
    "question": "What type of errors is GitHub Copilot best suited to handle?",
    "choice_a": "Logic errors",
    "choice_b": "Syntax errors",
    "choice_c": "Memory errors",
    "choice_d": "Runtime errors",
    "correct_answer": "A",
    "explanation": "GitHub Copilot is particularly good with logic errors, as the LLM can detect complex patterns. The other errors mentioned in the question are usually better handled by a compiler.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      183
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 133,
    "question": "What kind of data can GitHub Copilot create?",
    "choice_a": "Randomized data",
    "choice_b": "Synthetic data that can be used for testing",
    "choice_c": "Sensor data",
    "choice_d": "Real-time data for streaming",
    "correct_answer": "B",
    "explanation": "With a prompt, you can have GitHub Copilot create data, such as for logins. This can also be in a certain format, such as JSON. As for the other answers, GitHub does not use randomization to generate data. Also, the AI model does not create data that is streamed in real time or sensor data. For this, you need to use specialized tools.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      179,
      182,
      180
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 134,
    "question": "In which phase of the SDLC process can you use GitHub Copilot?",
    "choice_a": "Requirements analysis",
    "choice_b": "Design and development",
    "choice_c": "Deployment",
    "choice_d": "All of the phases",
    "correct_answer": "D",
    "explanation": "Because of its training on an extensive dataset, GitHub Copilot can be useful for all phases of the SDLC process.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      190,
      191,
      168,
      183,
      174
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 135,
    "question": "What can you do with the REST API or productivity API for GitHub Copilot?",
    "choice_a": "Get metrics on the usage of GitHub Copilot.",
    "choice_b": "Create AI applications.",
    "choice_c": "Access different AI models.",
    "choice_d": "Integrate with third-party applications.",
    "correct_answer": "A",
    "explanation": "The GitHub Copilot REST API gives you access to usage metrics. Examples include the number of suggestions generated and the acceptance rates. This can help an organization measure the impact of the tool.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      195
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 136,
    "question": "What can you do with code translation in GitHub Copilot?",
    "choice_a": "You can convert text into another spoken language.",
    "choice_b": "You can create an API.",
    "choice_c": "You can convert code from one language into another one.",
    "choice_d": "You can integrate with third-party applications.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot can convert code from one language to another. But this process is far from perfect. The code translation is really meant as an initial step, which should be followed up with more extensive analysis and review.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      173
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 137,
    "question": "Among the following SDLC models, which one is best for software projects where there are frequent updates and collaboration between development and operations teams?",
    "choice_a": "DevOps",
    "choice_b": "Agile",
    "choice_c": "Lean development",
    "choice_d": "Waterfall",
    "correct_answer": "A",
    "explanation": "DevOps is an approach where development and operations teams work together. This helps with continuous integration, frequent updates, and automated testing.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      190,
      191
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 138,
    "question": "For GitHub Copilot, which capability is about optimizing code without changing its functionality?",
    "choice_a": "Automated deployment",
    "choice_b": "Code refactoring",
    "choice_c": "Waterfall",
    "choice_d": "Continuous development",
    "correct_answer": "B",
    "explanation": "With GitHub Copilot, you can refactor your code. This helps enhance readability, maintainability, and performance without changing the underlying functionality.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      174,
      173,
      175,
      183,
      168
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 139,
    "question": "When using GitHub Copilot, what is a drawback when using code refactoring?",
    "choice_a": "The inability to format the code.",
    "choice_b": "No option to use another AI model.",
    "choice_c": "The conflict with the proxy filter.",
    "choice_d": "Limited understanding of the entire codebase.",
    "correct_answer": "D",
    "explanation": "The context window limits the amount of code GitHub Copilot can process at a time. This means that it may not capture the full impact of the code refactoring.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      174,
      175,
      173
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 140,
    "question": "How can GitHub Copilot help with creating database schemas?",
    "choice_a": "You can use the SQL extension.",
    "choice_b": "The training data does not include SQL content.",
    "choice_c": "It can create scripts to define tables, fields, and relationships.",
    "choice_d": "It is restricted because of security reasons.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot is trained on extensive amounts of scripts for SQL. The result is that it can be a powerful tool when working with databases.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      180,
      179,
      182
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 141,
    "question": "How can GitHub Copilot help with writing requirements for a software project?",
    "choice_a": "This is beyond the scope of the tool.",
    "choice_b": "It can only write non-functional requirements.",
    "choice_c": "It can be automatically generated by adding notes to your prompt.",
    "choice_d": "It is integrated with Microsoft Word.",
    "correct_answer": "C",
    "explanation": "With GitHub Copilot, you can add one or more files for your requirements notes. Then you can write a prompt to create a requirements document.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      191,
      168,
      190
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 142,
    "question": "For these options, which best describes the extract method that GitHub Copilot can help with?",
    "choice_a": "Combining multiple methods into one.",
    "choice_b": "Moving functions into separate files.",
    "choice_c": "Dividing a large function into smaller ones for better clarity.",
    "choice_d": "Removing all comments to reduce clutter.",
    "correct_answer": "C",
    "explanation": "The extract method is a type of refactoring. It involves breaking down a large function into smaller, more manageable ones. This is something that GitHub Copilot can perform.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      174
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 143,
    "question": "What is the endpoint when using the REST API for an enterprise?",
    "choice_a": "GET /enterprises/{enterprise}/copilot/metrics.",
    "choice_b": "GET /copilot/usage/enterprise.",
    "choice_c": "GET /orgs/{org}/copilot/metrics.",
    "choice_d": "GET /enterprises.",
    "correct_answer": "A",
    "explanation": "This is the endpoint to use when accessing metrics about the use of GitHub in your enterprise.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      195
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 144,
    "question": "How can GitHub Copilot help with deploying applications onto the Azure cloud platform?",
    "choice_a": "You need to do this in Azure, not GitHub Copilot.",
    "choice_b": "You need to use the GitHub Copilot REST API.",
    "choice_c": "You can use the GitHub Copilot for Azure extension.",
    "choice_d": "You need to use GitHub Kubernetes.",
    "correct_answer": "C",
    "explanation": "You can use a prompt in GitHub Copilot. But a better approach is to use the GitHub Copilot for Azure extension, which is trained specifically for Azure deployment.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      191
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 145,
    "question": "How can GitHub Copilot interpret ninja code?",
    "choice_a": "By using code conversion.",
    "choice_b": "By using pseudocode.",
    "choice_c": "By using debugging techniques.",
    "choice_d": "By using /explain.",
    "correct_answer": "D",
    "explanation": "The /explain short-code will break down the complexities and attempt to understand what the code does.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      175
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 146,
    "question": "What command do you use in GitHub Copilot to understand regular expressions?",
    "choice_a": "/regex",
    "choice_b": "/regexplain",
    "choice_c": "/explain",
    "choice_d": "/debug",
    "correct_answer": "C",
    "explanation": "You highlight the code and use /explain. GitHub Copilot will understand that you want to know how the regular expression works.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      188,
      175
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 147,
    "question": "What is a disadvantage in using GitHub Copilot to detect dead code?",
    "choice_a": "It may not have the full context of the codebase.",
    "choice_b": "Dead code is not caught in the proxy filter.",
    "choice_c": "You need to use a vector database.",
    "choice_d": "It can introduce security vulnerabilities.",
    "correct_answer": "A",
    "explanation": "Because of the context window of the LLM, there is a fixed limit of how much information it can handle at once. This means it can miss important relationships.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      175
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 148,
    "question": "Which of the following can you use to fix a logic error in your code?",
    "choice_a": "/logicfix",
    "choice_b": "/test + /evaluate",
    "choice_c": "/fix + /logic",
    "choice_d": "/fix + /explain",
    "correct_answer": "D",
    "explanation": "This uses two short-code commands for your prompt: /fix and /explain. This will not only identify the logic error but will also provide an explanation.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      183,
      175
    ],
    "source": "349982_Ch06"
  },
  {
    "id": 149,
    "question": "Which of the following best describes the role of software testing in the Software Development Life Cycle (SDLC)?",
    "choice_a": "Software testing is only done when the code has been completely debugged.",
    "choice_b": "Software testing verifies if an application does what it is intended to do.",
    "choice_c": "Software testing only involves automated methods.",
    "choice_d": "Software testing is the same as Quality Assurance (QA).",
    "correct_answer": "B",
    "explanation": "The purpose of software testing is to ensure that the application does what it is intended to do. It is a core phase of the SDLC process.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      198,
      200,
      202
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 150,
    "question": "What is the role of unit testing in software development?",
    "choice_a": "To evaluate the overall functionality of a software project.",
    "choice_b": "To test individual functional units of the codebase in isolation.",
    "choice_c": "To ensure the software meets customer requirements before it goes into production.",
    "choice_d": "To identify performance issues with the software.",
    "correct_answer": "B",
    "explanation": "The focus of unit testing it to test individual functions or blocks of software code. It helps spot errors earlier in the process.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      200,
      201,
      205,
      198
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 151,
    "question": "What is a drawback of unit testing?",
    "choice_a": "It cannot be used with test-driven development (TDD).",
    "choice_b": "It is not automated.",
    "choice_c": "It is not available in GitHub Copilot.",
    "choice_d": "It does not allow for testing how various units of software interact with each other.",
    "correct_answer": "D",
    "explanation": "Unit testing will test individual parts of a codebase, not how they interact with each other. For this, you need to use integration testing.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      202,
      200,
      206
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 152,
    "question": "When writing unit tests, which is not a best practice?",
    "choice_a": "Having each test focus on a single expected outcome.",
    "choice_b": "Trying to anticipate potential pathways for the code.",
    "choice_c": "Writing tests for at least two functions.",
    "choice_d": "Keeping tests independent from one another.",
    "correct_answer": "C",
    "explanation": "Unit testing should be focused on one function or task. This helps isolate the root cause of the problem.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      201,
      200,
      205
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 153,
    "question": "What best describes test-driven development (TDD) when using unit testing?",
    "choice_a": "Tests are written before the code is implemented.",
    "choice_b": "TDD is only for integration testing.",
    "choice_c": "TDD is a manual approach to testing.",
    "choice_d": "TDD is for security scanning.",
    "correct_answer": "A",
    "explanation": "With TDD, you will write the tests before implementing the code. This is to help ensure that the code meets requirements and is reliable from the start.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      200,
      205,
      201,
      198
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 154,
    "question": "Why should unit tests be independent from one another?",
    "choice_a": "It increases the speed of the testing.",
    "choice_b": "It ensures one failed test does not affect the outcomes of other tests.",
    "choice_c": "It means there is no need for automated tools.",
    "choice_d": "It means that all test cases will pass on the first attempt.",
    "correct_answer": "B",
    "explanation": "Keeping unit tests independent helps isolate failures. This makes it easier to identify and fix issues.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      201,
      200,
      205
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 155,
    "question": "What is the purpose of integration testing?",
    "choice_a": "To test separate functional units of the codebase in isolation.",
    "choice_b": "To focus only on debugging the code.",
    "choice_c": "To create tests before writing the code.",
    "choice_d": "To evaluate the interactions between different components of the code.",
    "correct_answer": "D",
    "explanation": "With integration testing, you test how the different components of the code interact. This can identify bugs and conflicts.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      202,
      206,
      200
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 156,
    "question": "Which integration testing technique begins by testing the core modules and then moves downward to other ones?",
    "choice_a": "Bottom-up integration testing",
    "choice_b": "Exploratory integration testing",
    "choice_c": "Top-down integration testing",
    "choice_d": "Big-bang integration testing",
    "correct_answer": "C",
    "explanation": "With top-down integration testing, the tests begin with the higher-level modules. You then add the lower-level modules incrementally.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      202
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 157,
    "question": "What is an advantage of using GitHub Copilot for unit testing?",
    "choice_a": "It covers all edge cases available.",
    "choice_b": "It generates boilerplate unit test code.",
    "choice_c": "It automatically fixes failed tests.",
    "choice_d": "It eliminates the need for manual test reviews.",
    "correct_answer": "B",
    "explanation": "GitHub Copilot automates the process of creating unit tests. It does this by generating boilerplate tests that are based on the relevant function or class.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      205,
      200,
      198
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 158,
    "question": "Which command will generate unit tests in GitHub Copilot?",
    "choice_a": "/tests",
    "choice_b": "/setupTests",
    "choice_c": "/unittests",
    "choice_d": "/units",
    "correct_answer": "A",
    "explanation": "By using /tests in a prompt, GitHub Copilot will create boilerplate unit tests.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      205,
      201,
      200
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 159,
    "question": "What is a drawback when using the /tests slash command in GitHub Copilot?",
    "choice_a": "It cannot generate tests for functions that include mathematical calculations.",
    "choice_b": "It does not allow customization of the generated test framework or test structure.",
    "choice_c": "It only supports JavaScript and Python for creating unit tests.",
    "choice_d": "It does not work with testing frameworks like pytest or unittest.",
    "correct_answer": "B",
    "explanation": "With /tests, you cannot customize it, such as for the test framework. You need to write a custom prompt for this.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      205,
      201,
      200
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 160,
    "question": "What is a best practice when using GitHub Copilot to generate unit tests?",
    "choice_a": "Run code coverage tools to identify untested parts of the code.",
    "choice_b": "Avoid using custom prompts.",
    "choice_c": "Always specify the testing framework.",
    "choice_d": "Identify all the edge cases.",
    "correct_answer": "A",
    "explanation": "While GitHub Copilot can create useful unit tests, they are usually not complete. You can use coverage tools to help out. You should also do a code review.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      205,
      201,
      200
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 161,
    "question": "Why should you use mocks for external API calls when writing integration tests for a function?",
    "choice_a": "To avoid making real API calls and ensuring tests run consistently.",
    "choice_b": "To increase the speed of the tests.",
    "choice_c": "To automatically fix bugs in the API.",
    "choice_d": "To allow direct modification of API responses in production.",
    "correct_answer": "A",
    "explanation": "A mock prevents an actual network request. Rather, it will simulate this process. This means that the result of the test will not be impacted by other factors, which could make it tough to determine the root cause of the issue.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      206,
      202,
      200
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 162,
    "question": "What is a best practice for generating integration tests for API calls using GitHub Copilot?",
    "choice_a": "Allow GitHub Copilot to generate tests without reviewing them.",
    "choice_b": "Use specific prompts to ensure edge cases like timeouts and invalid JSON responses are tested.",
    "choice_c": "Always make real API calls to get the most accurate test results.",
    "choice_d": "Avoid testing for HTTP errors, as they rarely occur in production.",
    "correct_answer": "B",
    "explanation": "Providing more details for the scenarios in the prompt can be helpful, such as with HTTP errors, invalid JSON responses, and timeouts.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      206,
      205,
      202
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 163,
    "question": "Which is not one of GitHub’s core privacy principles?",
    "choice_a": "Respect for user privacy",
    "choice_b": "Transparency and control",
    "choice_c": "Privacy by design",
    "choice_d": "Complete anonymity for all users",
    "correct_answer": "D",
    "explanation": "Privacy is a major priority for GitHub. The company has a set of principles that include respecting user data, transparency, and privacy by design.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      213,
      214
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 164,
    "question": "How does GitHub allow users to manage their privacy settings?",
    "choice_a": "By providing options to make their profile and email private.",
    "choice_b": "By preventing users from exporting their data.",
    "choice_c": "By requiring all repositories to be private.",
    "choice_d": "By requiring an Enterprise plan.",
    "correct_answer": "A",
    "explanation": "GitHub offers various ways to protect privacy, such as by making profiles private and hiding email addresses.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      214,
      213
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 165,
    "question": "Which version of GitHub Copilot provides organization-wide policy management and file exclusion?",
    "choice_a": "Free and Individual (Pro)",
    "choice_b": "Business and Enterprise",
    "choice_c": "Individual (Pro) and Business",
    "choice_d": "All versions of GitHub Copilot",
    "correct_answer": "B",
    "explanation": "For organization-wide policy management and file exclusion, you need either the Business or Enterprise edition of GitHub Copilot.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      217,
      218,
      219
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 166,
    "question": "Which of the following privacy features are available only in the Business and Enterprise editions of GitHub Copilot?",
    "choice_a": "Audit logs",
    "choice_b": "Exclusion of files",
    "choice_c": "Blocking of suggestions matching public code",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Audit logs, exclusion of files, and blocking of suggestions matching public code are all only part of the Business and Enterprise editions of GitHub Copilot. This is generally because these tools are focused on larger organizations, which have more privacy needs.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      217,
      218,
      219
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 167,
    "question": "What is a reason for configuring content exclusions in GitHub Copilot?",
    "choice_a": "To speed up Copilot’s response time when generating code.",
    "choice_b": "To prevent sensitive data like API keys and passwords from being used in code suggestions.",
    "choice_c": "To allow Copilot to generate more accurate responses by accessing all repository files.",
    "choice_d": "To disable GitHub Copilot for a repository.",
    "correct_answer": "B",
    "explanation": "Contention exclusions will protect sensitive data—like API keys, passwords and personal user information—from being indexed for code suggestions.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      218,
      217,
      213
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 168,
    "question": "Which of the following steps can help resolve issues if GitHub Copilot is not providing code suggestions?",
    "choice_a": "Restarting the IDE and checking for Copilot extension updates.",
    "choice_b": "Deleting the configuration files in the repository.",
    "choice_c": "Reinstalling your IDE.",
    "choice_d": "Configuring the settings in GitHub.com.",
    "correct_answer": "A",
    "explanation": "A reason GitHub may not generate suggestions is that the extension is outdated.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      224
    ],
    "source": "349982_Ch07"
  },
  {
    "id": 169,
    "question": "Which GitHub Copilot version has organization-wide policy management features?",
    "choice_a": "Copilot Individual",
    "choice_b": "Copilot Business",
    "choice_c": "Copilot Chat",
    "choice_d": "Copilot Pro",
    "correct_answer": "B",
    "explanation": "Policy management is included starting with Copilot Business for better control across teams.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      92,
      102,
      57,
      93
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 170,
    "question": "When using GitHub Copilot Chat, what does the @workspace reference help with?",
    "choice_a": "Searching the web for programming tutorials.",
    "choice_b": "Sending feedback to GitHub support.",
    "choice_c": "Providing context from the active project files.",
    "choice_d": "Encrypting the repository settings.",
    "correct_answer": "C",
    "explanation": "@workspace allows Copilot to pull relevant information from your current project for better answers.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      67,
      65,
      69,
      68,
      98
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 171,
    "question": "Which GitHub Copilot privacy setting controls whether your prompts and suggestions are collected for analysis?",
    "choice_a": "Block external repositories",
    "choice_b": "Secure history mode",
    "choice_c": "Prompt and suggestion collection setting",
    "choice_d": "Duplication filter activation",
    "correct_answer": "C",
    "explanation": "This privacy setting allows users to opt out of GitHub collecting their prompt and suggestion history.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      214,
      217,
      213,
      218
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 172,
    "question": "Why is understanding the structure of programming languages still important when using AI coding systems?",
    "choice_a": "Because AI models automatically fix bugs without human review.",
    "choice_b": "Because AI models generate code without needing verification.",
    "choice_c": "Because developers must review, debug, and maintain AI-generated code.",
    "choice_d": "Because AI coding systems only work with a few languages.",
    "correct_answer": "C",
    "explanation": "Developers must understand programming basics to review and correct issues in AI-generated code.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      37,
      20,
      19,
      17,
      4
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 173,
    "question": "What drawback can happen when you apply too many content exclusions in GitHub Copilot?",
    "choice_a": "Copilot will stop suggesting secure coding practices.",
    "choice_b": "Suggestions may lack important project context and become less useful.",
    "choice_c": "Copilot will prioritize outdated code examples.",
    "choice_d": "GitHub will automatically delete private repositories.",
    "correct_answer": "B",
    "explanation": "Overuse of exclusions can limit the context available to Copilot, leading to weaker or incomplete suggestions.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      218
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 174,
    "question": "What concept is promoted by Microsoft’s responsible AI principles?",
    "choice_a": "Replacing human oversight with AI automation.",
    "choice_b": "Prioritizing transparency, fairness, and accountability in AI systems.",
    "choice_c": "Maximizing AI speed at the cost of explainability.",
    "choice_d": "Developing AI tools that work only in the private sector.",
    "correct_answer": "B",
    "explanation": "Microsoft’s responsible AI guidelines emphasize fairness, transparency, privacy, security, and accountability.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      27,
      26,
      18
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 175,
    "question": "Which key benefit of GitHub Copilot makes it similar to a virtual “pair programmer”?",
    "choice_a": "It deploys code to production without human review.",
    "choice_b": "It locks files to prevent unwanted edits.",
    "choice_c": "It enforces strict compliance rules automatically.",
    "choice_d": "It offers real-time feedback and suggestions while coding.",
    "correct_answer": "D",
    "explanation": "GitHub Copilot acts like a virtual pair programmer, offering instant suggestions and support while coding.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      47,
      46,
      70,
      65,
      84
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 176,
    "question": "Which statement best describes the impact of AI coding tools like GitHub Copilot on traditional software development?",
    "choice_a": "They allow developers to rely less on syntax and more on higher-level thinking.",
    "choice_b": "They have made manual coding obsolete.",
    "choice_c": "They guarantee perfect code with no errors.",
    "choice_d": "They eliminate the need for software architecture planning.",
    "correct_answer": "A",
    "explanation": "AI coding tools shift developer focus toward problem-solving and prompt engineering instead of manual code syntax.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      37,
      4,
      1,
      20,
      9
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 177,
    "question": "How does GitHub Copilot Business handle subscription seat management?",
    "choice_a": "It requires an external billing provider.",
    "choice_b": "It automatically assigns seats based on programming language usage.",
    "choice_c": "It allows flexible addition or removal of seats with billing adjustments.",
    "choice_d": "It only allows yearly seat adjustments.",
    "correct_answer": "C",
    "explanation": "GitHub Copilot Business lets organizations flexibly manage and adjust seat licenses throughout the billing cycle.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      92,
      57,
      102,
      93,
      62
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 178,
    "question": "Which GitHub Copilot feature is limited to 50 interactions per month on the free plan?",
    "choice_a": "Inline suggestions",
    "choice_b": "Copilot Chat",
    "choice_c": "Code completion",
    "choice_d": "CLI integrations",
    "correct_answer": "B",
    "explanation": "Free plan users are limited to 50 Copilot Chat interactions monthly.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      57,
      102,
      65,
      64,
      62
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 179,
    "question": "Which of the following is not a primary use for GitHub audit logs?",
    "choice_a": "Monitoring system access.",
    "choice_b": "Investigating potential security incidents.",
    "choice_c": "Encrypting repositories automatically.",
    "choice_d": "Maintaining records for compliance reviews.",
    "correct_answer": "C",
    "explanation": "Audit logs provide a history of system actions but do not handle encryption tasks.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      218,
      217
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 180,
    "question": "If a developer wants GitHub Copilot to suggest a new Node.js project structure, which feature should they use?",
    "choice_a": "/new slash command",
    "choice_b": "@terminal prompt",
    "choice_c": "@vscode integration",
    "choice_d": "Copilot Edits",
    "correct_answer": "A",
    "explanation": "The /new slash command can scaffold a project structure like Node.js in the workspace.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      66,
      65,
      69,
      71
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 181,
    "question": "Which AI technology enables systems to learn from rewards and punishments while interacting with an environment?",
    "choice_a": "Supervised learning",
    "choice_b": "Reinforcement learning",
    "choice_c": "Deep learning",
    "choice_d": "Generative AI",
    "correct_answer": "B",
    "explanation": "Reinforcement learning trains AI agents through trial and error based on feedback from their actions.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      7
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 182,
    "question": "What main advantage does GitHub Copilot Enterprise offer compared to Business and Individual plans?",
    "choice_a": "Expanded audit log history",
    "choice_b": "Pull request summaries for private repositories",
    "choice_c": "Access to knowledge bases for improving code suggestions",
    "choice_d": "Unlimited free Copilot seats",
    "correct_answer": "C",
    "explanation": "Knowledge bases allow GitHub Copilot Enterprise users to embed organizational standards directly into Copilot suggestions.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      98,
      102,
      57,
      97,
      99
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 183,
    "question": "Which plan is best suited for a solo developer using GitHub Copilot?",
    "choice_a": "Copilot Business",
    "choice_b": "Copilot Enterprise",
    "choice_c": "Copilot Individual",
    "choice_d": "Copilot Academic",
    "correct_answer": "C",
    "explanation": "Copilot Individual is designed for freelancers, students, and solo developers.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      57,
      88,
      87,
      102,
      62
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 184,
    "question": "Why would a developer add a mock object during an integration test?",
    "choice_a": "To speed up database queries.",
    "choice_b": "To simulate external systems like APIs during testing.",
    "choice_c": "To minimize memory usage.",
    "choice_d": "To automatically generate unit tests.",
    "correct_answer": "B",
    "explanation": "Mocks simulate the behavior of external systems, allowing developers to test integrations without depending on live services.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      206,
      202,
      200
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 185,
    "question": "What is the purpose of GitHub Copilot’s code referencing feature?",
    "choice_a": "To create pull request templates automatically.",
    "choice_b": "To generate documentation summaries.",
    "choice_c": "To highlight missing unit tests in a project.",
    "choice_d": "To detect AI-generated code that matches public repositories.",
    "correct_answer": "D",
    "explanation": "Code referencing checks whether Copilot’s output closely matches public codebases to prevent licensing issues.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      88,
      228,
      102
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 186,
    "question": "What is one benefit of GitHub Copilot being integrated into GitHub.com?",
    "choice_a": "It eliminates the need for IDEs.",
    "choice_b": "It improves collaboration directly in repositories.",
    "choice_c": "It requires developers to use only Azure.",
    "choice_d": "It blocks non-GitHub users from making commits.",
    "correct_answer": "B",
    "explanation": "Having Copilot integrated into GitHub.com improves collaboration on issues, pull requests, and code discussions.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      72,
      102,
      87,
      65,
      46
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 187,
    "question": "What is a major advantage of transformer-based models like GPT over older RNN models?",
    "choice_a": "They process text token-by-token, without needing full context.",
    "choice_b": "They use attention mechanisms to understand entire sequences simultaneously.",
    "choice_c": "They avoid using any mathematical calculations for predictions.",
    "choice_d": "They require fewer computing resources than RNNs.",
    "correct_answer": "B",
    "explanation": "Transformer models use self-attention to understand full sequences at once, improving speed and accuracy.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      9
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 188,
    "question": "When explaining highly complex “ninja code,” which Copilot Chat feature is most helpful?",
    "choice_a": "/debug",
    "choice_b": "/refactor",
    "choice_c": "/explain",
    "choice_d": "/recompile",
    "correct_answer": "C",
    "explanation": "Using /explain in Copilot Chat breaks down cryptic code into understandable explanations.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      175,
      183,
      188,
      174
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 189,
    "question": "Which GitHub Copilot feature helps automate user assignments and track subscription usage?",
    "choice_a": "GitHub Actions workflows",
    "choice_b": "REST API for Copilot Business and Enterprise",
    "choice_c": "Code review via AI-native experiences",
    "choice_d": "Inline context modeling",
    "correct_answer": "B",
    "explanation": "The REST API provides automation options for subscription management, seat assignment, and usage reporting.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      92,
      102,
      57,
      93
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 190,
    "question": "Which GitHub Copilot feature allows you to modify multiple files with a single prompt?",
    "choice_a": "Chat variables",
    "choice_b": "Inline chat",
    "choice_c": "Copilot Edits",
    "choice_d": "Pull Request Reviews",
    "correct_answer": "C",
    "explanation": "Copilot Edits enables multi-file updates based on user instructions.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      71,
      66,
      102,
      65,
      69
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 191,
    "question": "Why should developers use code coverage tools after writing unit tests?",
    "choice_a": "To speed up deployments.",
    "choice_b": "To install GitHub Copilot updates.",
    "choice_c": "To format documentation automatically.",
    "choice_d": "To find parts of the code that have not been tested.",
    "correct_answer": "D",
    "explanation": "Code coverage tools highlight the parts of the code that are not covered by existing tests.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      205,
      200,
      201
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 192,
    "question": "What is one reason an organization might create a custom model instead of only using knowledge bases?",
    "choice_a": "To gain direct access to GitHub’s internal training datasets.",
    "choice_b": "To fine-tune the model’s internal weights and produce more accurate predictions.",
    "choice_c": "To remove the need for software developers.",
    "choice_d": "To support unlimited repository imports automatically.",
    "correct_answer": "B",
    "explanation": "Custom models allow internal model tuning based on an organization’s own coding practices, leading to better predictions.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      99,
      102,
      98,
      97,
      57
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 193,
    "question": "What is a way to apply content exclusions while maintaining Copilot’s usefulness?",
    "choice_a": "Only exclude files that contain sensitive or confidential information.",
    "choice_b": "Exclude the entire repository.",
    "choice_c": "Remove all third-party libraries.",
    "choice_d": "Enable exclusions for all languages.",
    "correct_answer": "A",
    "explanation": "Limiting exclusions to truly sensitive files helps protect privacy while preserving enough context for strong suggestions.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      218,
      217,
      219
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 194,
    "question": "Which GitHub Copilot capability assists with converting CSV data to XML format?",
    "choice_a": "@csvtool",
    "choice_b": "Data pipeline generator",
    "choice_c": "Simple prompt and Chat",
    "choice_d": "/data-convert slash command",
    "correct_answer": "C",
    "explanation": "By simply prompting Copilot via Chat, developers can convert data formats like CSV to XML.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      182
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 195,
    "question": "How long does GitHub Copilot retain audit log data for organizations?",
    "choice_a": "28 days",
    "choice_b": "60 days",
    "choice_c": "90 days",
    "choice_d": "180 days",
    "correct_answer": "D",
    "explanation": "Audit logs in GitHub Copilot Business and Enterprise are retained for 180 days for compliance and security monitoring.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      93,
      102,
      57
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 196,
    "question": "What is a limitation of the pull request summary feature in GitHub Copilot?",
    "choice_a": "It can only summarize changes for up to 30 files.",
    "choice_b": "It requires a custom model to work.",
    "choice_c": "It only functions with public repositories.",
    "choice_d": "It deletes branch histories automatically.",
    "correct_answer": "A",
    "explanation": "GitHub Copilot’s pull request summaries are limited to analyzing the first 30 modified files for efficiency reasons.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      87,
      72,
      102,
      55,
      57
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 197,
    "question": "Which REST API endpoint would you use to pull GitHub Copilot usage metrics for an organization?",
    "choice_a": "/orgs/{org}/copilot/metrics",
    "choice_b": "/metrics/org/{org_id}",
    "choice_c": "/copilot/stats",
    "choice_d": "/metrics/codex/summary",
    "correct_answer": "A",
    "explanation": "The correct endpoint is /orgs/{org}/copilot/metrics for retrieving usage statistics at the organizational level.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      195
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 198,
    "question": "What best explains why high-quality data is critical for AI systems like GitHub Copilot?",
    "choice_a": "High-quality data improves training speed but lowers accuracy.",
    "choice_b": "High-quality data ensures outputs are more accurate and reduces bias in suggestions.",
    "choice_c": "High-quality data prevents the need for model updates.",
    "choice_d": "High-quality data allows the AI to operate without cloud computing.",
    "correct_answer": "B",
    "explanation": "Better data leads to more accurate predictions and fewer biases in AI-generated results.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      127,
      111,
      108
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 199,
    "question": "Which GitHub Copilot command helps generate unit tests for a selected block of code?",
    "choice_a": "/setupTests",
    "choice_b": "/createTests",
    "choice_c": "/tests",
    "choice_d": "/unitCheck",
    "correct_answer": "C",
    "explanation": "The /tests command in GitHub Copilot automatically generates unit test templates for highlighted code sections.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      205,
      201,
      200
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 200,
    "question": "What happens when GitHub Copilot processes a prompt in an Individual account (by default)?",
    "choice_a": "The prompt is encrypted and stored for future model updates.",
    "choice_b": "The prompt is analyzed and then immediately discarded after a response.",
    "choice_c": "The prompt is automatically shared with GitHub repositories.",
    "choice_d": "The prompt is sent to Microsoft for archiving.",
    "correct_answer": "B",
    "explanation": "By default, GitHub Copilot processes prompts but does not store them after generating a response.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      120,
      123,
      117
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 201,
    "question": "During model processing, why might GitHub Copilot prioritize information from the active file?",
    "choice_a": "To speed up training for future model updates.",
    "choice_b": "To avoid using any external files for completions.",
    "choice_c": "Because the most relevant context usually comes from the file the developer is working on.",
    "choice_d": "To ensure compliance with global privacy regulations.",
    "correct_answer": "C",
    "explanation": "Copilot favors the active file’s context because it is typically the most relevant to what the user is coding.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      123,
      127
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 202,
    "question": "What is a hallucination in the context of generative AI?",
    "choice_a": "When an AI system produces factual but outdated content.",
    "choice_b": "When an AI model generates incorrect or misleading outputs.",
    "choice_c": "When an AI system crashes due to memory overload.",
    "choice_d": "When an AI model repeats user prompts verbatim.",
    "correct_answer": "B",
    "explanation": "A hallucination occurs when a model generates information that appears correct but is actually wrong or fabricated.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      17,
      19,
      26,
      9,
      20
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 203,
    "question": "Why might a company prefer Copilot Enterprise over Copilot Business?",
    "choice_a": "Copilot Enterprise is free for all organizations.",
    "choice_b": "Copilot Enterprise only works with public repositories.",
    "choice_c": "Copilot Business offers better compliance controls.",
    "choice_d": "Copilot Enterprise includes deeper customization for internal codebases.",
    "correct_answer": "D",
    "explanation": "Copilot Enterprise offers enhanced customization for company-specific codebases and security needs.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      102,
      98,
      99,
      57,
      97
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 204,
    "question": "Why do developers need to review Copilot’s code suggestions even if a safety filter is applied?",
    "choice_a": "The safety filter prevents all possible bugs.",
    "choice_b": "The filter guarantees perfect documentation.",
    "choice_c": "Safety filters reduce risks but cannot eliminate errors or vulnerabilities.",
    "choice_d": "Copilot automatically deploys reviewed code to production.",
    "correct_answer": "C",
    "explanation": "While safety filters help, human review is still critical to catch errors or security vulnerabilities.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      123,
      127
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 205,
    "question": "What does the telemetry data collected by GitHub Copilot mainly include?",
    "choice_a": "Full repository contents",
    "choice_b": "Metrics, interaction events, and error logs",
    "choice_c": "Developer usernames and passwords",
    "choice_d": "Encrypted copies of all code suggestions",
    "correct_answer": "B",
    "explanation": "Telemetry data focuses on usage metrics, interaction patterns, and error reporting to improve system performance.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      120
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 206,
    "question": "Which prompting technique involves giving the AI examples before asking it to complete a task?",
    "choice_a": "Zero-shot prompting",
    "choice_b": "Prompt chaining",
    "choice_c": "Few-shot prompting",
    "choice_d": "Multimodal prompting",
    "correct_answer": "C",
    "explanation": "Few-shot prompting uses a few examples to show the LLM what type of response is expected.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      143
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 207,
    "question": "Why is it important to be clear when writing a prompt?",
    "choice_a": "It ensures the LLM responds faster.",
    "choice_b": "It eliminates the need for user testing.",
    "choice_c": "It reduces hallucinations and improves the relevance of the response.",
    "choice_d": "It triggers automatic code generation.",
    "correct_answer": "C",
    "explanation": "Clear prompts help the LLM stay focused and generate more accurate and reliable outputs.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      141,
      144,
      140,
      139,
      142
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 208,
    "question": "What is the first step in the GitHub Copilot code completion data flow?",
    "choice_a": "Model training",
    "choice_b": "Post-processing",
    "choice_c": "Prompt crafting",
    "choice_d": "Tokenization",
    "correct_answer": "C",
    "explanation": "Prompt crafting is the initial step, where in-file context, metadata, and comments are processed to build a strong input for the model.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      123
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 209,
    "question": "Which GitHub Copilot version supports creating and maintaining custom AI models tailored to an organization’s coding standards?",
    "choice_a": "Copilot Individual",
    "choice_b": "Copilot Business",
    "choice_c": "Copilot Enterprise",
    "choice_d": "Copilot Free Tier",
    "correct_answer": "C",
    "explanation": "Custom models are available exclusively with Copilot Enterprise, providing highly personalized AI behavior.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      99,
      102,
      57,
      97,
      98
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 210,
    "question": "What role does GitHub Copilot’s proxy service play in managing user prompts?",
    "choice_a": "It delays responses for additional security reviews.",
    "choice_b": "It blocks or sanitizes sensitive data before reaching the AI model.",
    "choice_c": "It duplicates prompts for training backup purposes.",
    "choice_d": "It prevents users from submitting multiline prompts.",
    "correct_answer": "B",
    "explanation": "The proxy service acts as a filter, removing sensitive content or blocking prompts that pose risks.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      117,
      123,
      116
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 211,
    "question": "In Chain-of-Thought (CoT) prompting, which approach improves the model’s reasoning?",
    "choice_a": "Breaking complex tasks into smaller, logical steps",
    "choice_b": "Asking only yes/no questions",
    "choice_c": "Using only single-word prompts",
    "choice_d": "Limiting the LLM to 10 tokens per response",
    "correct_answer": "A",
    "explanation": "Chain-of-Thought prompting structures the solution as small reasoning steps, improving accuracy.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      143,
      144,
      139,
      141,
      140
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 212,
    "question": "When excluding content from GitHub Copilot code completions, what happens to the excluded file information?",
    "choice_a": "It is stored permanently on GitHub servers.",
    "choice_b": "It is processed temporarily without being logged.",
    "choice_c": "It is encrypted and sent to third-party providers.",
    "choice_d": "It is shared with public repositories.",
    "correct_answer": "B",
    "explanation": "Excluded files are processed in real time but not stored or logged, enhancing privacy protections.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      93,
      102,
      88
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 213,
    "question": "What is a common cause of hallucinations in AI-generated outputs?",
    "choice_a": "Too many delimiters used in the prompt",
    "choice_b": "Using few-shot examples",
    "choice_c": "Switching programming languages mid-prompt",
    "choice_d": "Lack of specificity in the prompt instruction",
    "correct_answer": "D",
    "explanation": "Vague or unclear instructions can lead the LLM to “fill in” information incorrectly.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      141,
      144,
      139,
      140,
      143
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 214,
    "question": "How can you use GitHub Copilot to create realistic sample login data?",
    "choice_a": "Import from an external JSON feed",
    "choice_b": "Generate fake users and passwords through a prompt",
    "choice_c": "Clone a public database",
    "choice_d": "Scrape live user data",
    "correct_answer": "B",
    "explanation": "Copilot can create fake yet realistic user accounts and login details when asked via a prompt.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      179
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 215,
    "question": "Which best describes how GitHub Copilot currently handles multimodal inputs like images?",
    "choice_a": "Images must be processed separately using a Vision extension.",
    "choice_b": "GitHub Copilot fully supports multimodal inputs by default.",
    "choice_c": "Copilot requires OpenAI API keys to process text prompts only.",
    "choice_d": "Copilot blocks multimodal input completely.",
    "correct_answer": "A",
    "explanation": "Image handling currently requires GitHub’s Copilot Vision extension or similar integrations.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      157
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 216,
    "question": "What feature does GitHub Copilot offer to protect organizations from IP-related legal issues?",
    "choice_a": "IP integration",
    "choice_b": "Audit logging",
    "choice_c": "Public code filter with IP indemnity",
    "choice_d": "Slash command customization",
    "correct_answer": "C",
    "explanation": "Enabling public code filters allows customers to qualify for IP indemnity protection against infringement claims.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      93,
      88,
      102,
      228
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 217,
    "question": "How is agentic AI expected to change the nature of prompt crafting in the future?",
    "choice_a": "Prompts will become longer and more detailed.",
    "choice_b": "Prompts will no longer be needed.",
    "choice_c": "Prompts will become shorter and focus more on setting goals.",
    "choice_d": "Prompts will require programming knowledge in multiple languages.",
    "correct_answer": "C",
    "explanation": "With agentic AI systems, prompts will likely shift toward short, goal-driven instructions, while the AI figures out complex steps autonomously.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      160,
      135,
      134
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 218,
    "question": "Why can GitHub Copilot sometimes offer outdated code suggestions?",
    "choice_a": "Copilot always rewrites code using outdated libraries for compatibility.",
    "choice_b": "The underlying training data may not include the newest frameworks.",
    "choice_c": "Copilot accesses random data sources in real time.",
    "choice_d": "Copilot purposely delays learning new programming trends.",
    "correct_answer": "B",
    "explanation": "Copilot relies on training data collected up to a certain cutoff, meaning newer frameworks might be missing.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      127,
      111,
      108
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 219,
    "question": "When using delimiters like ### in a prompt, what are you trying to achieve?",
    "choice_a": "Encrypt user data",
    "choice_b": "Highlight important metadata",
    "choice_c": "Separate instructions from content",
    "choice_d": "Track code changes in a repository",
    "correct_answer": "C",
    "explanation": "Delimiters help clearly separate user instructions from the input content to reduce confusion for the model.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      140,
      139,
      141,
      142,
      144
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 220,
    "question": "Which feature makes GitHub Copilot a useful tool for learning a new framework?",
    "choice_a": "It provides video tutorials automatically.",
    "choice_b": "It generates personalized, example-based code explanations.",
    "choice_c": "It limits access to basic commands only.",
    "choice_d": "It installs libraries without permission.",
    "correct_answer": "B",
    "explanation": "GitHub Copilot can customize explanations and examples based on user prompts, helping new learners.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      163,
      175,
      164,
      188,
      170
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 221,
    "question": "Which benchmark is commonly used to evaluate an LLM’s ability to solve software engineering tasks?",
    "choice_a": "SWE-bench",
    "choice_b": "ImageNet",
    "choice_c": "HumanEval",
    "choice_d": "BigCodeBench",
    "correct_answer": "A",
    "explanation": "SWE-bench tests an LLM’s ability to solve real-world software development issues from GitHub repositories.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      34
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 222,
    "question": "Which GitHub Copilot feature would you use if you wanted to ask questions about settings in VS Code?",
    "choice_a": "@terminal",
    "choice_b": "@workspace",
    "choice_c": "@vscode",
    "choice_d": "#selection",
    "correct_answer": "C",
    "explanation": "The @vscode reference is used to ask Copilot questions about the editor, features, and settings.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      67,
      65,
      69,
      64
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 223,
    "question": "If GitHub Copilot suddenly stops suggesting code, what is a recommended first step to fix it?",
    "choice_a": "Disable your Internet connection.",
    "choice_b": "Update or reinstall the GitHub Copilot extension in your IDE.",
    "choice_c": "Turn off your firewall settings.",
    "choice_d": "Open a support case immediately.",
    "correct_answer": "B",
    "explanation": "Updating the Copilot extension or reinstalling it often resolves issues with missing code suggestions.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      224
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 224,
    "question": "Which part of a prompt tells the AI the specific task it should perform?",
    "choice_a": "Format",
    "choice_b": "Context",
    "choice_c": "Instructions",
    "choice_d": "Input content",
    "correct_answer": "C",
    "explanation": "Instructions guide the LLM to know what action it should take in response to a prompt.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      139,
      140,
      141,
      142,
      143
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 225,
    "question": "When writing documentation with GitHub Copilot, which format is often suggested for API guides?",
    "choice_a": "HTML",
    "choice_b": "JSON",
    "choice_c": "Markdown",
    "choice_d": "XML",
    "correct_answer": "C",
    "explanation": "Markdown is commonly used for clear, easy-to-read API documentation generated by Copilot.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      168
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 226,
    "question": "Which type of bugs are GitHub Copilot especially good at helping developers fix?",
    "choice_a": "Runtime errors",
    "choice_b": "Syntax errors",
    "choice_c": "Logic errors",
    "choice_d": "Memory management issues",
    "correct_answer": "C",
    "explanation": "Copilot excels at detecting logic flaws, where the code runs but produces unintended results.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      183,
      175,
      174
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 227,
    "question": "How can GitHub Copilot support database development?",
    "choice_a": "It generates schemas defining tables and relationships.",
    "choice_b": "It deploys live database servers.",
    "choice_c": "It automatically encrypts all database fields.",
    "choice_d": "It prevents SQL injection attacks during runtime.",
    "correct_answer": "A",
    "explanation": "Copilot can generate SQL schemas, including tables and relationships, based on developer prompts.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      180
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 228,
    "question": "What is the main purpose of slash commands in GitHub Copilot Chat?",
    "choice_a": "To create branch protections automatically.",
    "choice_b": "To perform quick tasks like testing or fixing code.",
    "choice_c": "To configure GitHub Actions workflows.",
    "choice_d": "To encrypt the project files in real time.",
    "correct_answer": "B",
    "explanation": "Slash commands like /test and /fix enable fast, targeted actions inside Copilot Chat.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      66,
      87,
      65,
      102
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 229,
    "question": "What does the duplication detector feature in GitHub Copilot prevent?",
    "choice_a": "Generating repeated filenames.",
    "choice_b": "Recommending open-source code snippets too similar to existing public code.",
    "choice_c": "Downloading incomplete repositories.",
    "choice_d": "Adding duplicate licenses to a project.",
    "correct_answer": "B",
    "explanation": "The duplication detector helps avoid suggesting code that closely matches public open-source repositories.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      219,
      217,
      218
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 230,
    "question": "What is a major risk of relying heavily on AI-generated synthetic data for model training?",
    "choice_a": "It guarantees higher model performance over time.",
    "choice_b": "It leads to significantly faster training cycles without risk.",
    "choice_c": "It can degrade model performance through feedback loops.",
    "choice_d": "It prevents hallucinations from appearing in outputs.",
    "correct_answer": "C",
    "explanation": "Synthetic data can introduce feedback loops, weakening model performance over time.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      108,
      111,
      127
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 231,
    "question": "Which technique helps improve Copilot’s performance by adjusting response times based on urgency?",
    "choice_a": "Content injection",
    "choice_b": "Latency tradeoff optimization",
    "choice_c": "Server-side encryption",
    "choice_d": "Global synchronization delays",
    "correct_answer": "B",
    "explanation": "Copilot uses latency tradeoffs to balance speed and response quality based on user actions and expectations.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      116,
      123,
      107,
      120,
      108
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 235,
    "question": "Which statement best describes GitHub Copilot's role across the software development lifecycle (SDLC)?",
    "choice_a": "It can completely replace human requirements analysis.",
    "choice_b": "It can independently replace testing and quality assurance.",
    "choice_c": "It can design and develop production systems without human review.",
    "choice_d": "It can assist across SDLC phases, but its output still requires human review and validation.",
    "correct_answer": "D",
    "explanation": "GitHub Copilot can support activities across the SDLC, including requirements exploration, design, development, testing, and documentation. However, it is an assistive tool rather than a replacement for human expertise. Users remain responsible for reviewing, validating, securing, and testing its output.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      190,
      191,
      168,
      183,
      174
    ],
    "source": "349982_PracticeExam"
  },
  {
    "id": 233,
    "question": "Which type of files are commonly included in a GitHub Copilot Enterprise Knowledge Base?",
    "choice_a": "Executable binaries",
    "choice_b": "Markdown files with code samples and best practices",
    "choice_c": "Dynamic libraries (.dll)",
    "choice_d": "IDE installation files",
    "correct_answer": "B",
    "explanation": "Knowledge bases consist mainly of markdown documents containing best practices, design patterns, and reusable snippets.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      98,
      102,
      97,
      57,
      65
    ],
    "source": "349982_PracticeExam"
  }
];
